import * as i1 from '@angular/common';
import { CommonModule, DatePipe } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, InjectionToken, forwardRef, Directive, Inject, HostBinding, HostListener, EventEmitter, Component, Input, Output, ViewChild, ContentChildren, ViewChildren, ContentChild, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgClickOutsideDirective } from 'ng-click-outside2';
import * as i5 from '@appkit4/angular-components/datepicker';
import { DatepickerModule } from '@appkit4/angular-components/datepicker';
import focusTrap from 'focus-trap';
import { convertToRem, convertToRelativePx } from '@appkit4/angular-components/utils';
import * as i3 from '@appkit4/angular-api';
import * as i4 from '@appkit4/angular-components/shared';

class FieldService {
    constructor() { }
    formatNum(num, format) {
        if (!num) {
            return num;
        }
        let numberStr = num.toString();
        let result = '', counter = 0;
        const isMinus = numberStr.indexOf('-');
        if (isMinus === 0) {
            numberStr = numberStr.slice(1);
        }
        const index = numberStr.indexOf('.');
        if (index !== -1) {
            const beforeDot = numberStr.substring(0, index);
            for (let i = beforeDot.length - 1; i >= 0; i--) {
                counter++;
                result = beforeDot.charAt(i) + result;
                if (!(counter % 3) && i !== 0) {
                    result = format + result;
                }
            }
            if (isMinus === 0) {
                return '-' + result + numberStr.substring(index, numberStr.length);
            }
            else {
                return result + numberStr.substring(index, numberStr.length);
            }
        }
        else {
            for (let i = numberStr.length - 1; i >= 0; i--) {
                counter++;
                result = numberStr.charAt(i) + result;
                if (!(counter % 3) && i !== 0) {
                    result = format + result;
                }
            }
            if (isMinus === 0) {
                return '-' + result;
            }
            else {
                return result;
            }
        }
    }
    removeFormatInNumber(value, format) {
        if (!value && value !== 0) {
            return '';
        }
        return value.toString().replaceAll(format, '');
    }
    isNumber(value) {
        if (value === '') {
            return false;
        }
        return !isNaN(value);
    }
    // Include minNum and maxNum
    isInMinMax(value, maxNum, minNum) {
        const number = Number(value);
        if (((maxNum || maxNum === 0) && number > maxNum) || ((minNum || minNum === 0) && number < minNum)) {
            return false;
        }
        return true;
    }
    // Exclude minNum and maxNum
    isInsideMinMax(value, maxNum, minNum) {
        const number = Number(value);
        if (((maxNum || maxNum === 0) && number >= maxNum) || ((minNum || minNum === 0) && number <= minNum)) {
            return false;
        }
        return true;
    }
    getClosestNumberValue(value, maxNum, minNum) {
        const number = Number(value);
        if ((maxNum || maxNum === 0) && number >= maxNum) {
            return maxNum.toString();
        }
        if ((minNum || minNum === 0) && number <= minNum) {
            return minNum.toString();
        }
        return '0';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FieldService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FieldService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FieldService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [] });

const FIELD_COMPONENT = new InjectionToken("FieldComponent");
class FieldDirective {
    constructor(element, render, cdr, fieldComponent, datePipe, fieldService) {
        this.element = element;
        this.render = render;
        this.cdr = cdr;
        this.datePipe = datePipe;
        this.fieldService = fieldService;
        this.id = "";
        this.ariaLabel = "";
        this.basic = true;
        this.value = "";
        this.onModelChange = (_) => { };
        this.onTouched = () => { };
        this.fieldComponent = fieldComponent;
    }
    onChange($event) {
        this.handleChange($event);
    }
    onInput($event) {
        const modelToPropagate = $event.target
            ? $event.target.value
            : $event.value;
        if (this.fieldComponent.datepicker) {
            this.onModelChange(this.fieldComponent.selectedDatesFormValue);
        }
        else {
            this.onModelChange(modelToPropagate);
        }
        if (this.fieldComponent.datepicker) {
            this.writeValue(modelToPropagate);
        }
        this.handleInput($event);
        // setTimeout(() => {
        //   this.onValidationChange();
        // });
    }
    onBlur($event) {
        this.onTouched();
        this.handleBlur($event);
        // setTimeout(() => {
        //   this.onValidationChange();
        // });
    }
    onFocus($event) {
        this.handleFocus($event);
    }
    onClick($event) {
        // this.element.nativeElement.focus();
        this.handleClick($event);
    }
    handleChange(event) { }
    handleInput(event) { }
    handleBlur(event) { }
    handleFocus(event) { }
    handleClick(event) { }
    // setDisabled(isDisabled: boolean): void { }
    checkLength() { }
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    // setDisabledState(isDisabled: boolean) {
    //   this.disabled = isDisabled;
    //   this.setDisabled(isDisabled);
    // }
    writeValue(modelToPropagate) {
        this.value = modelToPropagate;
        if (this.fieldComponent.datepicker &&
            modelToPropagate &&
            typeof modelToPropagate === "object") {
            let dateValue = "", textInput = "";
            if (modelToPropagate.length >= 2 &&
                modelToPropagate[0] instanceof Date &&
                modelToPropagate[1] instanceof Date) {
                if (this.fieldComponent.dpRange) {
                    // dateValue = `${this.fieldComponent.getFormattedDate(modelToPropagate[0])} ${this.fieldComponent.dpRangeConnectorFormat} ${this.fieldComponent.getFormattedDate(modelToPropagate[1])}`;
                    dateValue = `${this.datePipe.transform(modelToPropagate[0], this.fieldComponent.customFormatWithSeparator)} ${this.fieldComponent.dpRangeConnectorFormat} ${this.datePipe.transform(modelToPropagate[1], this.fieldComponent.customFormatWithSeparator)}`;
                }
                else {
                    // dateValue = `${this.fieldComponent.getFormattedDate(modelToPropagate[0])}`;
                    dateValue = `${this.datePipe.transform(modelToPropagate[0], this.fieldComponent.customFormatWithSeparator)}`;
                }
                if (this.fieldComponent.dpDateSeparator === "_") {
                    textInput = dateValue
                        .replace(` ${this.fieldComponent.dpRangeConnectorFormat} `, "+ap+connector+")
                        .replaceAll(this.fieldComponent.dpDateSeparator, "/")
                        .replace("+ap+connector+", "_ap_connector_");
                }
                else {
                    textInput = dateValue
                        .replace(` ${this.fieldComponent.dpRangeConnectorFormat} `, "_ap_connector_")
                        .replaceAll(this.fieldComponent.dpDateSeparator, "/");
                }
            }
            textInput = this.fieldComponent.dpError
                ? textInput
                : this.fieldComponent.convertToDateString(textInput);
            this.fieldComponent.dateTextInput = this.fieldComponent.dpError
                ? `Invalid Date@${new Date().getTime().toString()}`
                : textInput === ""
                    ? `Empty Date@${new Date().getTime().toString()}`
                    : `${textInput}@${new Date().getTime().toString()}`;
            this.render.setProperty(this.element.nativeElement, "value", dateValue);
        }
        else if (this.fieldComponent.type === "appkit-number") {
            this.value = this.fieldService.removeFormatInNumber(this.value, this.fieldComponent.format);
            // Set disabled state for input number
            if (this.fieldComponent.numberRef) {
                if (this.fieldService.isNumber(this.value)) {
                    if ((this.fieldComponent.maxNum ||
                        this.fieldComponent.maxNum === 0) &&
                        Number(this.value) >= this.fieldComponent.maxNum) {
                        this.fieldComponent.numberRef.upDisabled = true;
                    }
                    else {
                        this.fieldComponent.numberRef.upDisabled = false;
                    }
                    if ((this.fieldComponent.minNum ||
                        this.fieldComponent.minNum === 0) &&
                        Number(this.value) <= this.fieldComponent.minNum) {
                        this.fieldComponent.numberRef.downDisabled = true;
                    }
                    else {
                        this.fieldComponent.numberRef.downDisabled = false;
                    }
                }
                else {
                    this.fieldComponent.numberRef.upDisabled = false;
                    this.fieldComponent.numberRef.downDisabled = false;
                }
            }
            let value = modelToPropagate || modelToPropagate === 0
                ? modelToPropagate
                : "";
            this.render.setProperty(this.element.nativeElement, "value", value);
        }
        else {
            let value = modelToPropagate || modelToPropagate === 0
                ? modelToPropagate
                : "";
            this.render.setProperty(this.element.nativeElement, "value", value);
        }
        this.checkLength();
        this.cdr.detectChanges();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FieldDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: FIELD_COMPONENT }, { token: i1.DatePipe }, { token: FieldService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.11", type: FieldDirective, selector: "[appkit-field]", host: { listeners: { "change": "onChange($event)", "input": "onInput($event)", "blur": "onBlur($event)", "focus": "onFocus($event)", "click": "onClick($event)" }, properties: { "id": "this.id", "aria-label": "this.ariaLabel", "disabled": "this.disabled", "class.error": "this.error", "readonly": "this.readonly", "class.ap-field-input": "this.basic" } }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => FieldDirective),
                multi: true,
            },
            // {
            //   provide: NG_VALIDATORS,
            //   useExisting: forwardRef(() => FieldDirective),
            //   multi: true
            // }
        ], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FieldDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: "[appkit-field]",
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => FieldDirective),
                            multi: true,
                        },
                        // {
                        //   provide: NG_VALIDATORS,
                        //   useExisting: forwardRef(() => FieldDirective),
                        //   multi: true
                        // }
                    ],
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FIELD_COMPONENT]
                }] }, { type: i1.DatePipe }, { type: FieldService }], propDecorators: { id: [{
                type: HostBinding,
                args: ["id"]
            }], ariaLabel: [{
                type: HostBinding,
                args: ["aria-label"]
            }], disabled: [{
                type: HostBinding,
                args: ["disabled"]
            }], error: [{
                type: HostBinding,
                args: ["class.error"]
            }], readonly: [{
                type: HostBinding,
                args: ["readonly"]
            }], basic: [{
                type: HostBinding,
                args: ["class.ap-field-input"]
            }], onChange: [{
                type: HostListener,
                args: ["change", ["$event"]]
            }], onInput: [{
                type: HostListener,
                args: ["input", ["$event"]]
            }], onBlur: [{
                type: HostListener,
                args: ["blur", ["$event"]]
            }], onFocus: [{
                type: HostListener,
                args: ["focus", ["$event"]]
            }], onClick: [{
                type: HostListener,
                args: ["click", ["$event"]]
            }] } });
class FieldCleanerComponent {
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    clearText(event) {
        // event.stopPropagation();
        if (this.disabled ||
            this.readonly ||
            this.value === undefined ||
            this.value === "") {
            return;
        }
        this.onModelChange("");
        this.onTouched();
        this.writeValue("");
        this.onClear.emit(event);
        const input = this.el.nativeElement.parentNode.parentNode.querySelector("[appkit-field]");
        if (input && !input.disabled) {
            setTimeout(() => {
                input.focus();
            }, 0);
        }
    }
    writeValue(modelToPropagate) {
        this.value = modelToPropagate;
    }
    constructor(el, localizationConfig) {
        this.el = el;
        this.localizationConfig = localizationConfig;
        this.styleClass = "";
        this.style = "";
        this.disabled = false;
        this.readonly = false;
        this.onClear = new EventEmitter();
        this.value = "";
        this.onModelChange = (_) => { };
        this.onTouched = () => { };
    }
    ngOnInit() { }
    getLabel(labelKey) {
        return this.localizationConfig.translation ? this.localizationConfig.translation[labelKey] : null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FieldCleanerComponent, deps: [{ token: i0.ElementRef }, { token: i3.LocalizationConfig }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: FieldCleanerComponent, selector: "ap-field-cleaner", inputs: { styleClass: "styleClass", style: "style", disabled: "disabled", readonly: "readonly" }, outputs: { onClear: "onClear" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => FieldCleanerComponent),
                multi: true,
            },
        ], ngImport: i0, template: `
        <span
            class="ap-field-cleaner Appkit4-icon icon-circle-delete-outline ap-field-icon-btn {{
                styleClass
            }}"
            style="{{ style }}"
            (click)="clearText($event)"
            (keydown.enter)="clearText($event)"
            role="button"
            type="button"
            [class.disabled]="disabled || value === undefined || value === ''"
            [class.readonly]="readonly"
            [attr.aria-label]="getLabel('clear')"
            [attr.aria-disabled]="
                disabled || readonly || value === undefined || value === ''
            "
            [tabindex]="
                disabled || readonly || value === undefined || value === ''
                    ? -1
                    : 0
            "
        ></span>
    `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FieldCleanerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "ap-field-cleaner",
                    template: `
        <span
            class="ap-field-cleaner Appkit4-icon icon-circle-delete-outline ap-field-icon-btn {{
                styleClass
            }}"
            style="{{ style }}"
            (click)="clearText($event)"
            (keydown.enter)="clearText($event)"
            role="button"
            type="button"
            [class.disabled]="disabled || value === undefined || value === ''"
            [class.readonly]="readonly"
            [attr.aria-label]="getLabel('clear')"
            [attr.aria-disabled]="
                disabled || readonly || value === undefined || value === ''
            "
            [tabindex]="
                disabled || readonly || value === undefined || value === ''
                    ? -1
                    : 0
            "
        ></span>
    `,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => FieldCleanerComponent),
                            multi: true,
                        },
                    ],
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i3.LocalizationConfig }], propDecorators: { styleClass: [{
                type: Input
            }], style: [{
                type: Input
            }], disabled: [{
                type: Input
            }], readonly: [{
                type: Input
            }], onClear: [{
                type: Output
            }] } });
class FieldCounterComponent {
    constructor(element) {
        this.element = element;
        this.styleClass = "";
        this.style = "";
        this.value = "";
        this.max = 420;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FieldCounterComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: FieldCounterComponent, selector: "ap-field-counter", inputs: { styleClass: "styleClass", style: "style", value: "value", max: "max" }, ngImport: i0, template: `
        <div class="ap-field-counter {{ styleClass }}" style="{{ style }}">
            <span>{{ value ? value.length : 0 }}/{{ max }}</span>
        </div>
    `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FieldCounterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "ap-field-counter",
                    template: `
        <div class="ap-field-counter {{ styleClass }}" style="{{ style }}">
            <span>{{ value ? value.length : 0 }}/{{ max }}</span>
        </div>
    `,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { styleClass: [{
                type: Input
            }], style: [{
                type: Input
            }], value: [{
                type: Input
            }], max: [{
                type: Input
            }] } });
class FieldNumberComponent {
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    plusNumber(event) {
        if (this.disabled || this.upDisabled || this.readonly) {
            return;
        }
        let tempValue;
        if (!this.disablePlusMinusLogic) {
            if (!this.value && this.value !== 0) {
                this.value = "";
            }
            tempValue = this.fieldService.removeFormatInNumber(this.value.toString(), this.format);
            if (tempValue === "" || this.fieldService.isNumber(tempValue)) {
                tempValue = parseFloat((Number(tempValue) + this.step).toFixed(10));
                if (this.fieldService.isInMinMax(tempValue, this.maxNum, this.minNum)) {
                    this.value = this.fieldService.formatNum(tempValue, this.format);
                }
                else {
                    this.value = this.fieldService.formatNum(this.fieldService.getClosestNumberValue(tempValue, this.maxNum, this.minNum), this.format);
                }
            }
            else {
                this.value = this.fieldService.formatNum(this.fieldService.getClosestNumberValue(this.maxNum.toString(), this.maxNum, this.minNum), this.format);
            }
            if (this.padZero) {
                this.value = String(this.value).padStart(2, "0");
            }
            this.onModelChange(this.value);
            this.plusNum.emit(this.value);
        }
        else {
            this.plusNum.emit(event);
        }
    }
    minusNumber(event) {
        if (this.disabled || this.downDisabled || this.readonly) {
            return;
        }
        let tempValue;
        if (!this.disablePlusMinusLogic) {
            if (!this.value && this.value !== 0) {
                this.value = "";
            }
            tempValue = this.fieldService.removeFormatInNumber(this.value.toString(), this.format);
            if (tempValue === "" || this.fieldService.isNumber(tempValue)) {
                tempValue = parseFloat((Number(tempValue) - this.step).toFixed(10));
                if (this.fieldService.isInMinMax(tempValue, this.maxNum, this.minNum)) {
                    this.value = this.fieldService.formatNum(tempValue, this.format);
                }
                else {
                    this.value = this.fieldService.formatNum(this.fieldService.getClosestNumberValue(tempValue, this.maxNum, this.minNum), this.format);
                }
            }
            else {
                this.value = this.fieldService.formatNum(this.fieldService.getClosestNumberValue(this.minNum.toString(), this.maxNum, this.minNum), this.format);
            }
            if (this.padZero) {
                this.value = String(this.value).padStart(2, "0");
            }
            this.onModelChange(this.value);
            this.minusNum.emit(this.value);
        }
        else {
            this.minusNum.emit(event);
        }
    }
    formateNum(num) {
        let result = "", counter = 0;
        if (this.maxNum && num > this.maxNum) {
            num = this.maxNum;
        }
        if (this.minNum && num < this.minNum) {
            num = this.minNum;
        }
        num = num.toString();
        if (num === "") {
            return "";
        }
        const isMinus = num.indexOf("-");
        if (isMinus === 0) {
            num = num.slice(1);
        }
        const index = num.indexOf(".");
        if (index !== -1) {
            const beforeDot = num.substring(0, index);
            for (let i = beforeDot.length - 1; i >= 0; i--) {
                counter++;
                result = beforeDot.charAt(i) + result;
                if (!(counter % 3) && i !== 0) {
                    result = this.format + result;
                }
            }
            if (isMinus === 0) {
                return "-" + result + num.substring(index, num.length);
            }
            else {
                return result + num.substring(index, num.length);
            }
        }
        else {
            for (let i = num.length - 1; i >= 0; i--) {
                counter++;
                result = num.charAt(i) + result;
                if (!(counter % 3) && i !== 0) {
                    result = this.format + result;
                }
            }
            if (isMinus === 0) {
                return "-" + result;
            }
            else {
                return result;
            }
        }
    }
    writeValue(modelToPropagate) {
        this.value = modelToPropagate;
    }
    constructor(el, fieldService, localizationConfig) {
        this.el = el;
        this.fieldService = fieldService;
        this.localizationConfig = localizationConfig;
        this.styleClass = "";
        this.style = "";
        this.disabled = false;
        this.readonly = false;
        this.value = "";
        this.format = ",";
        this.step = 1;
        this.plusNum = new EventEmitter();
        this.minusNum = new EventEmitter();
        // Properties for internal usage of default time picker component.
        this.padZero = false;
        this.disablePlusMinusLogic = false;
        this.upDisabled = false;
        this.downDisabled = false;
        this.onModelChange = (_) => { };
        this.onTouched = () => { };
    }
    ngOnInit() { }
    getAriaLabel(labelKey) {
        return this.localizationConfig.translation.aria ? this.localizationConfig.translation.aria[labelKey] : null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FieldNumberComponent, deps: [{ token: i0.ElementRef }, { token: FieldService }, { token: i3.LocalizationConfig }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: FieldNumberComponent, selector: "ap-field-number", inputs: { styleClass: "styleClass", style: "style", disabled: "disabled", readonly: "readonly", minNum: "minNum", maxNum: "maxNum", value: "value", format: "format", step: "step", padZero: "padZero", disablePlusMinusLogic: "disablePlusMinusLogic" }, outputs: { plusNum: "plusNum", minusNum: "minusNum" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => FieldNumberComponent),
                multi: true,
            },
        ], ngImport: i0, template: `
        <div class="ap-field-number">
            <span
                class="ap-field-up Appkit4-icon icon-up-chevron-outline {{
                    styleClass
                }}"
                style="{{ style }}"
                (click)="plusNumber($event)"
                (keydown.enter)="plusNumber($event)"
                role="button"
                type="button"
                [class.disabled]="disabled || upDisabled"
                [class.readonly]="readonly"
                [attr.aria-label]="getAriaLabel('plusNumber')"
                [attr.aria-disabled]="disabled || upDisabled"
                [tabindex]="disabled || upDisabled ? -1 : 0"
            ></span>
            <span
                class="ap-field-down Appkit4-icon icon-up-chevron-outline rotate {{
                    styleClass
                }}"
                style="{{ style }}"
                (click)="minusNumber($event)"
                (keydown.enter)="minusNumber($event)"
                role="button"
                type="button"
                [class.disabled]="disabled || downDisabled"
                [class.readonly]="readonly"
                [attr.aria-label]="getAriaLabel('minusNumber')"
                [attr.aria-disabled]="disabled || downDisabled"
                [tabindex]="disabled || downDisabled ? -1 : 0"
            ></span>
        </div>
    `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FieldNumberComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "ap-field-number",
                    template: `
        <div class="ap-field-number">
            <span
                class="ap-field-up Appkit4-icon icon-up-chevron-outline {{
                    styleClass
                }}"
                style="{{ style }}"
                (click)="plusNumber($event)"
                (keydown.enter)="plusNumber($event)"
                role="button"
                type="button"
                [class.disabled]="disabled || upDisabled"
                [class.readonly]="readonly"
                [attr.aria-label]="getAriaLabel('plusNumber')"
                [attr.aria-disabled]="disabled || upDisabled"
                [tabindex]="disabled || upDisabled ? -1 : 0"
            ></span>
            <span
                class="ap-field-down Appkit4-icon icon-up-chevron-outline rotate {{
                    styleClass
                }}"
                style="{{ style }}"
                (click)="minusNumber($event)"
                (keydown.enter)="minusNumber($event)"
                role="button"
                type="button"
                [class.disabled]="disabled || downDisabled"
                [class.readonly]="readonly"
                [attr.aria-label]="getAriaLabel('minusNumber')"
                [attr.aria-disabled]="disabled || downDisabled"
                [tabindex]="disabled || downDisabled ? -1 : 0"
            ></span>
        </div>
    `,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => FieldNumberComponent),
                            multi: true,
                        },
                    ],
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: FieldService }, { type: i3.LocalizationConfig }], propDecorators: { styleClass: [{
                type: Input
            }], style: [{
                type: Input
            }], disabled: [{
                type: Input
            }], readonly: [{
                type: Input
            }], minNum: [{
                type: Input
            }], maxNum: [{
                type: Input
            }], value: [{
                type: Input
            }], format: [{
                type: Input
            }], step: [{
                type: Input
            }], plusNum: [{
                type: Output
            }], minusNum: [{
                type: Output
            }], padZero: [{
                type: Input
            }], disablePlusMinusLogic: [{
                type: Input
            }] } });
class FieldComponent {
    set dpSelectedDates(value) {
        this._selectedDates = value;
        if (this.triggerTextInputChange) {
            this.setInputDateValue(this.dpSelectedDates);
            this.updateFormValue(this.selectedDatesFormValue, this.value);
        }
        else {
            this.triggerTextInputChange = true;
        }
    }
    get dpSelectedDates() {
        return this._selectedDates;
    }
    // The same value as dpSelectedDates.
    // For listening to the value change from both the field component itself and the @Input property 'dpSelectedDates',
    // and then trigger input value change
    set selectedDatesFormValue(value) {
        this._selectedDatesFormValue = value;
        if (this.triggerTextInputChange) {
            this.setInputDateValue(this.selectedDatesFormValue);
            this.updateFormValue(this.selectedDatesFormValue, this.value);
        }
        else {
            this.triggerTextInputChange = true;
        }
    }
    get selectedDatesFormValue() {
        return this._selectedDatesFormValue;
    }
    constructor(render, element, cdr, dialogService, datePipe, datepickerService, fieldService, localizationConfig, focusIndicatorService) {
        this.render = render;
        this.element = element;
        this.cdr = cdr;
        this.dialogService = dialogService;
        this.datePipe = datePipe;
        this.datepickerService = datepickerService;
        this.fieldService = fieldService;
        this.localizationConfig = localizationConfig;
        this.focusIndicatorService = focusIndicatorService;
        this.styleClass = "";
        this.style = "";
        this.title = "";
        this.error = false;
        this.disabled = false;
        this.customImg = false;
        this.img = false;
        this.unit = false;
        this.type = "text";
        this.required = false;
        this.readonly = false;
        this.revealer = false;
        this.hideTitleOnInput = false;
        this.textReadonly = false;
        this.dropdown = [];
        this.fieldId = String.fromCharCode(65 + Math.floor(Math.random() * 26)) + Date.now();
        this.adaptivePosition = false;
        this.format = ",";
        this.onNumberChange = new EventEmitter();
        this.onKeydown = new EventEmitter();
        this.onClick = new EventEmitter();
        this.onClose = new EventEmitter();
        this.onShow = new EventEmitter();
        this.onClickOutside = new EventEmitter();
        this.onListItemFocus = new EventEmitter();
        // Datepicker properties
        this.datepicker = false;
        this.editable = true;
        this.useCustomValidation = false;
        this.disableOutsideClose = false;
        this.dpRange = true;
        this.dpAutoClose = true;
        this.dpCalendarPosition = "bottom-right";
        this.dpType = "single";
        this.dpCustom = false;
        this.dpOptions = [];
        this.dpMinDate = new Date(100, 0, 1);
        this.dpDateformat = "MM/dd/yyyy";
        this.dpDateSeparator = "/";
        this.dpShowOtherMonths = true;
        this.dpRangeConnectorFormat = "to";
        this.dpFirstDayOfWeek = 0;
        this.dpView = "date";
        this.dpSelectedDatesChange = new EventEmitter();
        this.dpOnDateInvalid = new EventEmitter();
        this.dpOnClickNavigators = new EventEmitter();
        this.dpError = false; // property for built-in validation logic of datepicker
        this._selectedDates = [];
        this._selectedDatesFormValue = [];
        this.hasLength = false;
        this.hasTooltip = false;
        this.value = "";
        this.show = false;
        this.cursorIndex = -1;
        this.dateTextInput = "";
        this.dateValue = "";
        this.triggerTextInputChange = true;
        this.currentView = 0;
        this.isValueEdited = false;
        this.dialogContainerId = "";
        this.dpErrorType = "";
        this.customFormatWithSeparator = this.dpDateformat;
        this.predefinedFormat = {
            date: ["MM/dd/yyyy", "dd/MM/yyyy", "yyyy/MM/dd", "yyyy/dd/MM"],
            month: ["MM/yyyy", "yyyy/MM"],
            year: ["yyyy"],
        };
        this.mergedDisableRanges = [];
        this.isDisabledConfig = {
            mergedDisableRanges: this.mergedDisableRanges,
            minDate: this.dpMinDate,
        };
        this.number = ""; // last valid number (not formatted)
        this.apFieldContainerId = "";
    }
    onclickOut(event, show) {
        // ccheck if click on current element
        if (event.target.shadowRoot) {
            // check before go through path element to reduce time
            const path = event.composedPath();
            let self = false;
            for (let i = 0; i < 5; i++) {
                if (path[i] &&
                    path[i].id &&
                    path[i].id.indexOf(this.apFieldContainerId) !== -1) {
                    self = true;
                    break;
                }
            }
            if (self) {
                return;
            }
        }
        this.toggleDropdown(event, show);
    }
    toggleDropdown(event, show) {
        // event.stopPropagation();
        if (this.disabled || this.readonly)
            return;
        if (this.show === false && show === false) {
            return;
        }
        if (!show && this.show) {
            this.show = false;
            // if (this.dropdownButton) {
            //     this.dropdownButton.nativeElement.setAttribute(
            //         "aria-activedescendant",
            //         ""
            //     );
            // }
            const dropdownItems = this.element.nativeElement.querySelectorAll(".ap-option-item");
            if (dropdownItems) {
                dropdownItems.forEach((o) => {
                    o.classList.remove("moved");
                });
            }
            this.activeItemEle = undefined;
            this.onClose.emit(event);
        }
        else {
            this.show = true;
            this.onShow.emit(event);
        }
    }
    updateProperties() {
        if (!this.inputRef) {
            return;
        }
        this.inputRef.element.nativeElement.id = "field-input-" + this.fieldId;
        // if (this.datepicker) {
        //   this.inputRef.element.nativeElement.setAttribute('aria-describedby', 'datepicker-format-' + this.fieldId);
        // }
        if (this.dropdown.length && this.selectedItem) {
            // this.inputRef.element.nativeElement.setAttribute('aria-describedby', 'field-dropdown-description-' + this.fieldId);
            const label = this.selectedItem.descValue
                ? `${this.title}, ${this.selectedItem.label}, ${this.selectedItem.descValue}`
                : `${this.title}, ${this.selectedItem.label}`;
            this.inputRef.element.nativeElement.setAttribute("aria-label", label);
        }
        this.inputRef.readonly =
            this.readonly ||
                this.textReadonly ||
                (this.datepicker && !this.editable);
        if (this.inputRef.element.nativeElement.nodeName === "INPUT" &&
            !this.revealer) {
            this.inputRef.element.nativeElement.type = this.type;
        }
        this.inputRef.disabled = this.disabled;
        this.inputRef.ariaLabel = this.ariaLabel;
        this.inputRef.error =
            this.error || (!this.useCustomValidation && this.dpError);
        if (this.textCounterRef) {
            const counterWidth = this.textCounterRef.element.nativeElement.querySelector(".ap-field-counter").offsetWidth || 42;
            this.titleContainerRef.nativeElement.style.maxWidth = `calc(100% - ${convertToRem(counterWidth + convertToRelativePx(26))})`;
        }
        if (this.clearTextRef) {
            this.clearTextRef.disabled = this.disabled;
            this.clearTextRef.readonly = this.readonly;
        }
        if (this.numberRef) {
            this.numberRef.disabled = this.disabled;
            this.numberRef.readonly = this.readonly;
            this.numberRef.format = this.format;
            this.numberRef.maxNum = this.maxNum;
            this.numberRef.minNum = this.minNum;
        }
        if (this.error || (!this.useCustomValidation && this.dpError)) {
            this.inputRef.element.nativeElement.setAttribute("aria-invalid", true);
            if (this.datepicker && !this.useCustomValidation) {
                this.inputRef.element.nativeElement.setAttribute("aria-errormessage", "datepicker-error-message-" + this.fieldId);
            }
        }
        else {
            this.inputRef.element.nativeElement.setAttribute("aria-invalid", false);
        }
        this.hasLength =
            !!this.inputRef.element.nativeElement.value &&
                !!this.inputRef.element.nativeElement.value.length;
        if (this.required) {
            this.inputRef.element.nativeElement.setAttribute("aria-required", true);
        }
        // else {
        //     this.inputRef.element.nativeElement.setAttribute(
        //         "aria-required",
        //         false
        //     );
        // }
    }
    validateDate(event) {
        setTimeout(() => {
            this.dpError = event;
            if (this.dpError && !this.useCustomValidation) {
                this.inputRef.element.nativeElement.setAttribute("aria-invalid", true);
                if (this.datepicker) {
                    this.inputRef.element.nativeElement.setAttribute("aria-errormessage", "datepicker-error-message-" + this.fieldId);
                    this.inputRef.element.nativeElement.setAttribute("aria-label", this.getAriaLabel('datepickerDisabledDateMessage'));
                    this.dpOnDateInvalid.emit({
                        value: this.inputRef.element.nativeElement.value,
                        invalid: true,
                    });
                }
            }
            else {
                this.inputRef.element.nativeElement.setAttribute("aria-invalid", false);
                if (this.datepicker) {
                    this.inputRef.element.nativeElement.removeAttribute("aria-label");
                    this.dpOnDateInvalid.emit({
                        value: this.inputRef.element.nativeElement.value,
                        invalid: false,
                    });
                }
            }
        }, 0);
    }
    checkTextarea() {
        return (this.inputRef &&
            this.inputRef.element &&
            this.inputRef.element.nativeElement.nodeName === "TEXTAREA");
    }
    checkPassword() {
        return (this.inputRef &&
            this.inputRef.element &&
            this.inputRef.element.nativeElement.type === "password");
    }
    checkPasswordExist() {
        return (this.inputRef &&
            this.inputRef.element &&
            this.inputRef.element.nativeElement.value);
    }
    mousedown(event) {
        if (this.disabled || this.readonly)
            return;
        if (!event.target.matches(".icon-datepicker-outline") &&
            !event.target.matches(".ap-field-dropdown-button-group") &&
            !event.target.matches(".ap-field-icon-btn.icon-down-chevron-outline") &&
            !event.target.matches(".ap-field-up") &&
            !event.target.matches(".ap-field-down")) {
            setTimeout(() => {
                this.inputRef.element.nativeElement.focus();
            }, 0);
        }
    }
    click(event) {
        if (this.disabled || this.readonly)
            return;
        this.onClick.emit(event);
        // if (this.datepicker && !event.target.matches('.icon-calendar-outline')) {
        //   this.showDatepicker(event);
        //   this.inputRef.element.nativeElement.focus();
        // }
    }
    toggleRevealer(event) {
        // event.stopPropagation();
        if (!this.inputRef ||
            this.disabled ||
            this.readonly ||
            !this.checkPasswordExist()) {
            return;
        }
        if (this.inputRef.element.nativeElement.type === "password") {
            this.inputRef.element.nativeElement.type = "text";
        }
        else {
            this.inputRef.element.nativeElement.type = "password";
        }
    }
    toggleDatepicker(event, focusAfterClose) {
        // event.stopPropagation();
        // event.stopPropagation();
        if (this.disabled || this.readonly)
            return;
        setTimeout(() => {
            if (this.attachedDOM) {
                this.relocateDatepickerDialog();
                this.setDatepickerDialog();
            }
        });
        if (this.datepickerRef.showDatepicker) {
            this.datepickerRef.close();
            this.element.nativeElement
                .querySelector(".ap-field-container")
                .classList.remove("open");
            this.onClose.emit(event);
            if (focusAfterClose) {
                this.inputRef.element.nativeElement.focus();
            }
        }
        else {
            this.datepickerRef.show(event, true);
            if (this.datepickerRef.showDatepicker) {
                this.element.nativeElement
                    .querySelector(".ap-field-container")
                    .classList.add("open");
                this.onShow.emit(event);
            }
            else {
                this.element.nativeElement
                    .querySelector(".ap-field-container")
                    .classList.remove("open");
                this.onClose.emit(event);
            }
        }
    }
    showDatepicker(event) {
        this.datepickerRef.show(event);
        this.element.nativeElement
            .querySelector(".ap-field-container")
            .classList.add("open");
        this.onShow.emit(event);
    }
    closeDatepicker(event, focusAfterClose) {
        if (!this.datepicker) {
            return;
        }
        if (this.datepickerRef.showDatepicker) {
            this.datepickerRef.close();
        }
        if (this.element.nativeElement
            .querySelector(".ap-field-container")
            .classList.contains("open")) {
            this.element.nativeElement
                .querySelector(".ap-field-container")
                .classList.remove("open");
            this.onClose.emit(event);
        }
        if (focusAfterClose) {
            setTimeout(() => {
                this.inputRef.element.nativeElement.focus();
            }, 400);
        }
    }
    clickOutside(event) {
        if (this.datepicker && (this.attachedDOM || this.disableOutsideClose)) {
            return;
        }
        if (this.datepicker) {
            // ccheck if click on current element
            if (event.target?.shadowRoot) {
                // check before go through path element to reduce time
                if (!this.datepicker)
                    return;
                const path = event.composedPath();
                let self = false;
                for (let i = 0; i < 10; i++) {
                    if (path[i] &&
                        path[i].id &&
                        path[i].id.indexOf(this.apFieldContainerId) !== -1) {
                        self = true;
                        break;
                    }
                }
                if (self) {
                    return;
                }
            }
            this.closeDatepicker(event);
            // auto complete the end date if there is only the start date in range mode
            if (this.dpRange &&
                this.dpSelectedDates.length === 1 &&
                this.dateValue.indexOf("_ap_connector_") < 0 &&
                this.dateTextInput.indexOf("Invalid Date") < 0) {
                this.dpSelectedDates.push(this.dpSelectedDates[0]);
                this.dpSelectedDatesChange.emit(this.formatSelectedDates(this.dpSelectedDates));
                this.selectedDatesFormValue = this.dpSelectedDates;
            }
        }
        this.onClickOutside.emit(event);
    }
    formatSelectedDates(selectedDates) {
        const date = [...selectedDates];
        return date.length === 2
            ? [
                new Date(date[0].getFullYear(), date[0].getMonth(), date[0].getDate(), 0, 0, 0),
                new Date(date[1].getFullYear(), date[1].getMonth(), date[1].getDate(), 23, 59, 59),
            ]
            : date.length === 1
                ? [
                    new Date(date[0].getFullYear(), date[0].getMonth(), date[0].getDate(), 0, 0, 0),
                ]
                : [];
    }
    onClickNavigators(event) {
        this.dpOnClickNavigators.emit(event);
    }
    textInputChange(event) {
        this.triggerTextInputChange = event;
    }
    selectItem(event, selectedItem) {
        let item = selectedItem || event.selected;
        if (item.disabled) {
            return;
        }
        this.dropdown.forEach((dropdownItem) => {
            if (dropdownItem.label === item.label) {
                dropdownItem.checked = true;
            }
            else {
                delete dropdownItem.checked;
            }
        });
        const dropdownItems = this.element.nativeElement.querySelectorAll(".ap-option-item:not(.disabled)");
        dropdownItems.forEach((o) => {
            if (o.querySelector(".ap-option-label").innerText === item.label) {
                o.classList.add("active");
                this.activeItemEle = o;
            }
            else {
                o.classList.remove("active");
            }
        });
        if (event.originEvent) {
            this.toggleDropdown(event.originEvent, false);
        }
        else {
            this.toggleDropdown(event, false);
        }
        setTimeout(() => {
            this.inputRef.element.nativeElement.focus();
        });
    }
    // setDropdownHeight(): void {
    //   const top = this.element.nativeElement.parentElement.getBoundingClientRect().top;
    //   const documentHeight = window.innerHeight;
    //   if (documentHeight - top - 64 >= 64) {
    //     this.dropdownHeight = `${documentHeight - top - 64}px`;
    //     this.up = false;
    //   } else {
    //     this.dropdownHeight = `${top - 16}px`;
    //     this.up = true;
    //   }
    // }
    dateChange(event) {
        const selectedDates = event.selectedDates;
        if (selectedDates.length) {
            // this.setInputDateValue(selectedDates);
            this.dpError = false;
            if (this.inputRef) {
                this.inputRef.element.nativeElement.removeAttribute("aria-label");
            }
            // this.cdr.markForCheck();
            // this.cdr.detectChanges();
            // this.updateFormValue();
        }
        setTimeout(() => {
            if (!this.dpError) {
                this.dpSelectedDatesChange.emit(selectedDates);
                this.selectedDatesFormValue = selectedDates;
            }
        }, 0);
    }
    // dateValueChange(event: any): void {
    //   this.dpOnDateChange.emit(event);
    // }
    updateFormValue(modelChangeValue, writeValue) {
        if (!this.inputRef) {
            return;
        }
        this.inputRef.onModelChange(modelChangeValue);
        this.inputRef.writeValue(writeValue);
    }
    // numberChange(event: Event) {
    //   if (this.type !== 'appkit-number') {
    //     return;
    //   }
    //   let value = (event.target as any).value;
    //   this.number = this.inputRef.element.nativeElement.value || '';
    //   const char1 = this.number.charAt(0);
    //   const char2 = this.number.charAt(1);
    //   const char3 = this.number.charAt(2);
    //   if (char1 === '.') { this.number = ''; }
    //   if (char1 === '-' && char2 === '.') { this.number = '-'; }
    //   if (char1 === '-' && char2 === '0' && char3 === '0') { this.number = '-0'; }
    //   this.number = this.number.toString()
    //     .replace(/[^\d.]/g, '')
    //     .replace(/\.{2,}/g, '.')
    //     .replace('.', '$#$')
    //     .replace(/\./g, '')
    //     .replace('$#$', '.');
    //   this.number = char1 === '-' ? char1 + this.number : this.number;
    //   this.number = this.formatNum(this.number);
    //   this.updateFormValue(this.number, this.number);
    // }
    // formatNum(num: string) {
    //   if (!num) return num;
    //   let number = parseInt(num);
    //   let result = '', counter = 0;
    //   if (Number.isNaN(number)) {
    //     number = 0;
    //   }
    //   if (this.maxNum && number > this.maxNum) {
    //     number = this.maxNum;
    //   }
    //   if (this.minNum && number < this.minNum) {
    //     number = this.minNum;
    //   }
    //   let numberStr = number.toString();
    //   const isMinus = numberStr.indexOf('-');
    //   if (isMinus === 0) {
    //     numberStr = numberStr.slice(1);
    //   }
    //   const index = numberStr.indexOf('.');
    //   if (index !== -1) {
    //     const beforeDot = numberStr.substring(0, index);
    //     for (let i = beforeDot.length - 1; i >= 0; i--) {
    //       counter++;
    //       result = beforeDot.charAt(i) + result;
    //       if (!(counter % 3) && i !== 0) { result = this.format + result; }
    //     }
    //     if (isMinus === 0) {
    //       return '-' + result + numberStr.substring(index, numberStr.length);
    //     } else {
    //       return result + numberStr.substring(index, numberStr.length);
    //     }
    //   } else {
    //     for (let i = numberStr.length - 1; i >= 0; i--) {
    //       counter++;
    //       result = numberStr.charAt(i) + result;
    //       if (!(counter % 3) && i !== 0) { result = this.format + result; }
    //     }
    //     if (isMinus === 0) {
    //       return '-' + result;
    //     } else {
    //       return result;
    //     }
    //   }
    // }
    onToggleKeydown(event, target) {
        if (this.readonly || this.disabled)
            return;
        this.onKeydown.emit(event);
        const keyCode = event.keyCode;
        if (target === "dropdown") {
            if (!this.dropdown.length)
                return;
            event.stopPropagation();
            if (keyCode === 27 || keyCode === 9) {
                // esc, tab
                this.toggleDropdown(event, false);
            }
            else if (keyCode === 40) {
                // down
                event.preventDefault();
                this.findNextItem("down", event);
            }
            else if (keyCode === 38) {
                // up
                event.preventDefault();
                this.findNextItem("up", event);
            }
            else if (keyCode === 13 || keyCode === 32) {
                // enter, space
                event.preventDefault();
                this.findNextItem("enter", event);
            }
            else if ((this.show && keyCode >= 65 && keyCode <= 90) ||
                (keyCode >= 97 && keyCode <= 122)) {
                this.onSearch(keyCode, event);
            }
        }
        else if (target === "revealer") {
            event.stopPropagation();
            if (!this.revealer)
                return;
            if (keyCode === 13) {
                this.toggleRevealer(event);
                this.inputRef.element.nativeElement.focus();
            }
        }
        else if (target === "datepicker") {
            // event.stopPropagation();
            if (keyCode === 13) {
                this.toggleDatepicker(event);
            }
            if (keyCode === 27) {
                event.preventDefault();
                this.closeDatepicker(event);
            }
            if (keyCode === 9) {
                if (this.datepickerRef.showDatepicker) {
                    event.preventDefault();
                    this.datepickerRef.getFocusCell();
                    const datepickerEle = this.datepickerRef.datepickerWrapperRef.nativeElement;
                    this.focusTrapEle = focusTrap(datepickerEle, {
                        returnFocusOnDeactivate: false,
                        clickOutsideDeactivates: true,
                        escapeDeactivates: true,
                    });
                    this.focusTrapEle.activate();
                }
            }
        }
        else if (target === "field") {
            if (this.datepicker) {
                // if (keyCode === 13) {
                //   if (event.target.matches('.ap-field-wrapper') || event.target.matches('[appkit-field]') || event.target.matches('.icon-datepicker-outline')) {
                //     this.datepickerRef.show(event);
                //   }
                // }
                if (keyCode === 27) {
                    event.preventDefault();
                    this.closeDatepicker(event, true);
                }
            }
        }
    }
    findNextItem(key, event) {
        if (!this.show) {
            this.toggleDropdown(event, true);
            const dropdownItems = this.element.nativeElement.querySelectorAll(".ap-option-item");
            let index = key === "up" ? dropdownItems.length - 1 : 0;
            if (this.selectedItem?.label) {
                this.dropdown.forEach((item, i) => {
                    if (item.label === this.selectedItem.label) {
                        index = i;
                        return;
                    }
                });
            }
            if (!this.activeItemEle) {
                if (event.type !== "click") {
                    dropdownItems[index].classList.add("moved");
                }
                else {
                    dropdownItems[index].classList.remove("moved");
                }
                this.activeItemEle = dropdownItems[index];
                this.itemId = this.activeItemEle.id;
            }
            else {
                dropdownItems.forEach((o) => {
                    if (o === this.activeItemEle) {
                        if (event.type !== "click") {
                            this.activeItemEle.classList.add("moved");
                        }
                        else {
                            this.activeItemEle.classList.remove("moved");
                        }
                        this.itemId = this.activeItemEle.id;
                    }
                    else {
                        o.classList.remove("moved");
                    }
                });
            }
            this.activeItem = this.dropdown.find((o) => o.label ===
                this.activeItemEle.querySelector(".ap-option-label")
                    .innerText);
            if (this.activeItem) {
                this.onListItemFocus.emit({ item: this.activeItem, event });
            }
            // if (this.dropdownButton) {
            //     this.dropdownButton.nativeElement.setAttribute(
            //         "aria-activedescendant",
            //         this.itemId
            //     );
            // }
        }
        else {
            if (key !== "enter") {
                const dropdownItems = this.element.nativeElement.querySelectorAll(".ap-option-item:not(.disabled)");
                const currentItemEle = this.element.nativeElement.querySelector(".ap-option-item.moved") ||
                    this.element.nativeElement.querySelector(".ap-option-item.active");
                let index = 0;
                dropdownItems.forEach((o, p) => {
                    if (o === currentItemEle) {
                        if (key === "up") {
                            index =
                                p - 1 < 0 ? dropdownItems.length - 1 : p - 1;
                        }
                        else {
                            index = p + 1 === dropdownItems.length ? 0 : p + 1;
                        }
                    }
                });
                currentItemEle.classList.remove("moved");
                if (event.type !== "click") {
                    dropdownItems[index].classList.add("moved");
                }
                this.activeItemEle = dropdownItems[index];
                this.itemId = this.activeItemEle.id;
                this.activeItem = this.dropdown.find((o) => o.label ===
                    this.activeItemEle.querySelector(".ap-option-label")
                        .innerText);
                this.onListItemFocus.emit({ item: this.activeItem, event });
                // if (this.dropdownButton) {
                //     this.dropdownButton.nativeElement.setAttribute(
                //         "aria-activedescendant",
                //         this.itemId
                //     );
                // }
            }
            else {
                this.activeItem = this.dropdown.find((o) => o.label ===
                    this.activeItemEle.querySelector(".ap-option-label")
                        .innerText);
                // this.selectItem(event, this.activeItem);
                this.dropdownListItem
                    .toArray()
                    .find((item) => item.inputId === this.activeItemEle.id)
                    ?.onSelectItem.next({
                    originEvent: event,
                    selected: this.activeItem,
                    eventType: "keydown",
                });
            }
        }
    }
    onSearch(key, event) {
        this.cursorIndex = this.dropdown.findIndex((item, id) => {
            return (item.label
                .toLowerCase()
                .indexOf(String.fromCharCode(key).toLowerCase()) === 0 &&
                id > this.cursorIndex &&
                !item.disabled);
        });
        if (this.cursorIndex === -1) {
            this.cursorIndex = this.dropdown.findIndex((item) => {
                return (item.label
                    .toLowerCase()
                    .indexOf(String.fromCharCode(key).toLowerCase()) ===
                    0 && !item.disabled);
            });
        }
        if (this.cursorIndex > -1) {
            const dropdownItems = this.element.nativeElement.querySelectorAll(".ap-option-item");
            dropdownItems.forEach((item) => {
                item.classList.remove("moved");
            });
            dropdownItems[this.cursorIndex].classList.add("moved");
            this.activeItemEle = dropdownItems[this.cursorIndex];
            this.activeItem = this.dropdown.find((o) => o.label ===
                this.activeItemEle.querySelector(".ap-option-label")
                    .innerText);
            this.itemId = this.activeItemEle.id;
            this.onListItemFocus.emit({
                item: this.activeItem,
                event,
                isFromKey: true,
            });
            // if (this.dropdownButton) {
            //     this.dropdownButton.nativeElement.setAttribute(
            //         "aria-activedescendant",
            //         this.itemId
            //     );
            // }
        }
    }
    // scrollIntoView(): void {
    //   const el = this.options.find((el, id) => id === this.cursorIndex);
    //   if (!el) { return; }
    //   const offset = 8;
    //   if (this.dropdownRef.nativeElement.scrollTop > el.nativeElement.offsetTop - offset) {
    //     this.dropdownRef.nativeElement.scrollTop = el.nativeElement.offsetTop - offset;
    //   }
    //   if ((this.dropdownRef.nativeElement.scrollTop +
    //     this.dropdownRef.nativeElement.offsetHeight) < (el.nativeElement.offsetTop + el.nativeElement.offsetHeight + offset)) {
    //     this.dropdownRef.nativeElement.scrollTop =
    //       el.nativeElement.offsetTop - this.dropdownRef.nativeElement.offsetHeight + el.nativeElement.offsetHeight + offset;
    //   }
    // }
    setInputDateValue(selectedDates) {
        if (selectedDates.length > 0) {
            if (selectedDates.length === 2 && this.dpRange) {
                // this.value = `${this.getFormattedDate(selectedDates[0])} ${this.dpRangeConnectorFormat} ${this.getFormattedDate(selectedDates[1])}`;
                this.value = `${this.datePipe.transform(selectedDates[0], this.customFormatWithSeparator)} ${this.dpRangeConnectorFormat} ${this.datePipe.transform(selectedDates[1], this.customFormatWithSeparator)}`;
            }
            else {
                // this.value = this.getFormattedDate(selectedDates[0]);
                this.value = this.datePipe.transform(selectedDates[0], this.customFormatWithSeparator);
            }
        }
        else {
            this.value = "";
        }
        this.dateValue = this.value;
    }
    // getFormattedDate(date: Date) {
    //   let year = date.getFullYear().toString();
    //   if (year.length === 3) {
    //     year = '0' + year;
    //   }
    //   let month = (1 + date.getMonth()).toString();
    //   month = month.length > 1 ? month : '0' + month;
    //   let day = date.getDate().toString();
    //   day = day.length > 1 ? day : '0' + day;
    //   if (this.dpView === 'month') {
    //     return month + this.dpDateSeparator + year;
    //   } else if (this.dpView === 'year') {
    //     return year;
    //   } else {
    //     return month + this.dpDateSeparator + day + this.dpDateSeparator + year;
    //   }
    // }
    currentViewChange(event) {
        this.currentView = event;
    }
    onDatepickerInputChange(event) {
        let formatInputValue = (event) => {
            let isRangePicker = this.dpRange;
            let dpRangeConnectorFormat = this.dpRangeConnectorFormat;
            let dateSeparator = this.dpDateSeparator || "/";
            let format = this.customFormatWithSeparator;
            const spaceLength = 2;
            const allowedLength = isRangePicker
                ? format.length * 2 +
                    spaceLength +
                    dpRangeConnectorFormat.length
                : format.length;
            const value = event.target.value;
            if (value.length > allowedLength)
                return value.substring(0, allowedLength);
            const stack = value.split("").filter((char) => {
                return !isNaN(Number(char)) && char !== " ";
            });
            const separatorPos = [];
            const connectorPos = isRangePicker ? format.length : -1;
            const isDelete = event.inputType === "deleteContentBackward";
            const compositeFormat = isRangePicker
                ? `${format} ${dpRangeConnectorFormat} ${format}`
                : format;
            for (let i = 0; i < compositeFormat.length; i++) {
                if (compositeFormat[i] === dateSeparator) {
                    separatorPos.push(i);
                }
            }
            let newStr = "";
            while (stack.length > 0) {
                newStr += stack.shift();
                let nextPos = newStr.length;
                if (separatorPos.indexOf(nextPos) !== -1) {
                    if (!isDelete || stack.length !== 0)
                        newStr += dateSeparator;
                }
                if (nextPos === connectorPos && stack.length !== 0) {
                    newStr += ` ${dpRangeConnectorFormat} `;
                }
            }
            return newStr;
        };
        // let addSeparatorToDateText = (value: string) => {
        //   if (this.dpView === 'date') {
        //     if (value.length === 2) {
        //       value = value.replace(/([\d])([\d])/, `$1$2${this.dpDateSeparator}`);
        //     } else if (value.length === 3) {
        //       value = value.replace(/([\d])([\d])([\d])/, `$1$2${this.dpDateSeparator}$3`);
        //     } else if (value.length === 4) {
        //       value = value.replace(/([\d])([\d])([\d])([\d])/, `$1$2${this.dpDateSeparator}$3$4${this.dpDateSeparator}`);
        //     } else if (value.length > 8) {
        //       value = value.replace(/([\d])([\d])([\d])([\d])/, `$1$2${this.dpDateSeparator}$3$4${this.dpDateSeparator}`).substring(0, 10);
        //     } else {
        //       value = value.replace(/([\d])([\d])([\d])([\d])/, `$1$2${this.dpDateSeparator}$3$4${this.dpDateSeparator}`);
        //     }
        //   } else if (this.dpView === 'month') {
        //     if (value.length > 6) {
        //       value = value.replace(/([\d])([\d])/, `$1$2${this.dpDateSeparator}`).substring(0, 7);
        //     } else {
        //       value = value.replace(/([\d])([\d])/, `$1$2${this.dpDateSeparator}`);
        //     }
        //   } else {
        //     if (value.length > 4) {
        //       value = value.substring(0, 4);
        //     }
        //   }
        //   return value;
        // }
        // if (!this.dpRange) {
        //   let value: string = event.target.value;
        //   value = value.replace(/[^\d]/g, '');
        //   if (event.inputType === 'deleteContentBackward' && !event.target.value.endsWith(this.dpDateSeparator) &&
        //     (this.dpView === 'date' && event.target.value.length < 7 ||
        //       this.dpView === 'month' && event.target.value.length < 3)) {
        //     value = value.substring(0, value.length - 1);
        //   }
        //   value = addSeparatorToDateText(value);
        //   event.target.value = value;
        // } else {
        //   const connecterLength = this.dpRangeConnectorFormat.length;
        //   let value: string = event.target.value;
        //   value = value.replace(/[^\d]/g, '');
        //   if (event.inputType === 'deleteContentBackward' && !event.target.value.endsWith(this.dpDateSeparator) &&
        //     (this.dpView === 'date' && (event.target.value.length < 7 || event.target.value.length > connecterLength + 13 && event.target.value.length < connecterLength + 19) ||
        //       this.dpView === 'month' && (event.target.value.length < 3 || event.target.value.length > connecterLength + 10 && event.target.value.length < connecterLength + 12))) {
        //     value = value.substring(0, value.length - 1);
        //   }
        //   if (this.dpView === 'date' && value.length < 9 ||
        //     this.dpView === 'month' && value.length < 7 ||
        //     this.dpView === 'year' && value.length < 5) {
        //     value = addSeparatorToDateText(value);
        //   } else {
        //     let valueArr = this.dpView === 'date' ? [value.substring(0, 8), value.substring(8)]
        //       : this.dpView === 'month' ? [value.substring(0, 6), value.substring(6)]
        //         : [value.substring(0, 4), value.substring(4)];
        //     value = `${addSeparatorToDateText(valueArr[0])} ${this.dpRangeConnectorFormat} ${addSeparatorToDateText(valueArr[1])}`;
        //   }
        //   event.target.value = value;
        // }
        if (this.predefinedFormat[this.dpView].findIndex((format) => format === this.dpDateformat) >= 0) {
            event.target.value = formatInputValue(event);
        }
        if (this.dpDateSeparator === "_") {
            this.dateValue = event.target.value
                .replace(` ${this.dpRangeConnectorFormat} `, "+ap+connector+")
                .replaceAll(this.dpDateSeparator, "/")
                .replace("+ap+connector+", "_ap_connector_");
        }
        else {
            this.dateValue = event.target.value
                .replace(` ${this.dpRangeConnectorFormat} `, "_ap_connector_")
                .replaceAll(this.dpDateSeparator, "/");
        }
    }
    validateDateValue(value) {
        let isValidDate = (value) => {
            if (value.length) {
                let month = 1, day = 1, year = 2001;
                if (this.dpView === "date") {
                    if (this.dpDateformat === "dd/MM/yyyy") {
                        month = parseInt(value.substring(3, 5));
                        day = parseInt(value.substring(0, 2));
                        year = parseInt(value.substring(6));
                    }
                    else if (this.dpDateformat === "yyyy/MM/dd") {
                        month = parseInt(value.substring(5, 7));
                        day = parseInt(value.substring(8));
                        year = parseInt(value.substring(0, 4));
                    }
                    else if (this.dpDateformat === "yyyy/dd/MM") {
                        month = parseInt(value.substring(8));
                        day = parseInt(value.substring(5, 7));
                        year = parseInt(value.substring(0, 4));
                    }
                    else {
                        // 'MM/dd/yyyy'
                        month = parseInt(value.substring(0, 2));
                        day = parseInt(value.substring(3, 5));
                        year = parseInt(value.substring(6));
                    }
                }
                else if (this.dpView === "month") {
                    if (this.dpDateformat === "yyyy/MM") {
                        month = parseInt(value.substring(5));
                        day = 1;
                        year = parseInt(value.substring(0, 4));
                    }
                    else {
                        // 'MM/yyyy'
                        month = parseInt(value.substring(0, 2));
                        day = 1;
                        year = parseInt(value.substring(3));
                    }
                }
                else {
                    month = 1;
                    day = 1;
                    year = parseInt(value);
                }
                const formattedDate = this.dpView === "month"
                    ? new Date(year, month - 1)
                    : new Date(year, month - 1, day);
                if (month !== formattedDate.getMonth() + 1 ||
                    day !== formattedDate.getDate() ||
                    year !== formattedDate.getFullYear()) {
                    this.dpErrorType = "invalid date";
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                return false;
            }
        };
        let validateSingleDateValue = (value) => {
            this.dpErrorType = "";
            if (!value)
                return true;
            if (value.length === 0) {
                return true;
            }
            else if (this.dpView === "date") {
                if (this.dpDateformat.endsWith("yyyy")) {
                    if (value.length > 0 && value.length < 9) {
                        this.dpErrorType = "invalid format";
                        return false;
                    }
                    else if (value.length === 9) {
                        if (value.charAt(6) === "0") {
                            this.dpErrorType = "invalid format";
                            return false;
                        }
                        else {
                            return isValidDate(value);
                        }
                    }
                    else if (value.length === 10) {
                        if (value.charAt(6) === "0" &&
                            value.charAt(7) === "0") {
                            this.dpErrorType = "invalid format";
                            return false;
                        }
                        else {
                            return isValidDate(value);
                        }
                    }
                }
                else {
                    if (value.length > 0 && value.length < 10) {
                        this.dpErrorType = "invalid format";
                        return false;
                    }
                    else if (value.length === 10) {
                        return isValidDate(value);
                    }
                }
            }
            else if (this.dpView === "month") {
                if (this.dpDateformat.endsWith("yyyy")) {
                    if (value.length > 0 && value.length < 6) {
                        this.dpErrorType = "invalid format";
                        return false;
                    }
                    else if (value.length === 6) {
                        if (value.charAt(3) === "0") {
                            this.dpErrorType = "invalid format";
                            return false;
                        }
                        else {
                            return isValidDate(value);
                        }
                    }
                    else if (value.length === 7) {
                        if (value.charAt(3) === "0" &&
                            value.charAt(4) === "0") {
                            this.dpErrorType = "invalid format";
                            return false;
                        }
                        else {
                            return isValidDate(value);
                        }
                    }
                }
                else {
                    if (value.length > 0 && value.length < 7) {
                        this.dpErrorType = "invalid format";
                        return false;
                    }
                    else if (value.length === 7) {
                        return isValidDate(value);
                    }
                }
            }
            else if (this.dpView === "year") {
                if (value.length > 0 && value.length < 3) {
                    this.dpErrorType = "invalid format";
                    return false;
                }
                else if (value.length === 3) {
                    if (value.charAt(0) === "0") {
                        this.dpErrorType = "invalid format";
                        return false;
                    }
                    else {
                        return isValidDate(value);
                    }
                }
                else if (value.length === 4) {
                    if (value.charAt(0) === "0" && value.charAt(1) === "0") {
                        this.dpErrorType = "invalid format";
                        return false;
                    }
                    else {
                        return isValidDate(value);
                    }
                }
            }
            return true;
        };
        if (this.dpRange) {
            let dateValue = [];
            value
                .split("_ap_connector_")
                .forEach((value, i) => {
                dateValue[i] = value;
            });
            if (validateSingleDateValue(dateValue[0]) &&
                validateSingleDateValue(dateValue[1])) {
                const convertedDateValue1 = dateValue[0] && dateValue[0].length
                    ? this.convertSingleDateString(dateValue[0])
                    : "";
                const convertedDateValue2 = dateValue[1] && dateValue[1].length
                    ? this.convertSingleDateString(dateValue[1])
                    : dateValue[0] && dateValue[0].length
                        ? convertedDateValue1
                        : "";
                const value1 = convertedDateValue1 && convertedDateValue1.length
                    ? new Date(convertedDateValue1)
                    : new Date();
                const value2 = convertedDateValue2 && convertedDateValue2.length
                    ? new Date(convertedDateValue2)
                    : new Date();
                // if (this.dpView === 'month') {
                //   value1 = dateValue[0] && dateValue[0].length ? new Date(parseInt(dateValue[0].substring(3)), parseInt(dateValue[0].substring(0, 2)) - 1, 1) : new Date();
                //   value2 = dateValue[1] && dateValue[1].length ? new Date(parseInt(dateValue[1].substring(3)), parseInt(dateValue[1].substring(0, 2)) - 1, 1) : new Date();
                // } else {
                //   value1 = new Date(dateValue[0]);
                //   value2 = new Date(dateValue[1]);
                // }
                if (this.datepickerService.isSameDay(value1, value2, this.currentView) === -1) {
                    this.dpErrorType = "invalid date";
                    return false;
                }
            }
            return (validateSingleDateValue(dateValue[0]) &&
                validateSingleDateValue(dateValue[1]));
        }
        else {
            return validateSingleDateValue(value);
        }
    }
    convertSingleDateString(value) {
        if (this.dpDateformat === "dd/MM/yyyy") {
            let dateParts = value.split("/");
            return `${dateParts[1]}/${dateParts[0]}/${dateParts[2]}`; // convert to 'MM/dd/yyyy'
        }
        else if (this.dpDateformat === "yyyy/dd/MM") {
            let dateParts = value.split("/");
            return `${dateParts[0]}/${dateParts[2]}/${dateParts[1]}`; // convert to 'yyyy/MM/dd'
        }
        else if (this.dpDateformat === "MM/yyyy") {
            let dateParts = value.split("/");
            return `${dateParts[1]}/${dateParts[0]}`; // convert to 'yyyy/MM'
        }
        else {
            return value;
        }
    }
    // convert date string like 'dd/MM/yyyy' to 'MM/dd/yyyy' which applies to js Date constructor
    convertToDateString(value) {
        let dateString = "";
        if (value && value.length) {
            let dateArr = value.split("_ap_connector_");
            if (dateArr.length > 1) {
                dateString =
                    this.convertSingleDateString(dateArr[0]) +
                        "_ap_connector_" +
                        this.convertSingleDateString(dateArr[1]);
            }
            else {
                dateString = this.convertSingleDateString(dateArr[0]);
            }
        }
        return dateString;
    }
    setPadding() {
        if (this.datepicker ||
            this.revealer ||
            this.clearTextRef ||
            this.hasTooltip ||
            this.numberRef) {
            const iconEle = this.numberRef
                ? this.element.nativeElement.querySelector(".ap-field-up")
                : this.element.nativeElement.querySelector(".ap-field-icon-btn");
            const offsetPadding = iconEle.getBoundingClientRect().width
                ? convertToRem(iconEle.getBoundingClientRect().width + convertToRelativePx(4))
                : "2.75rem";
            const offsetWidth = iconEle.getBoundingClientRect().width
                ? `calc(100% - ${convertToRem(iconEle.getBoundingClientRect().width + convertToRelativePx(20))})`
                : "calc(100% - 3.75rem)";
            this.inputRef.element.nativeElement.style.paddingRight =
                offsetPadding;
            this.titleContainerRef.nativeElement.style.maxWidth = offsetWidth;
        }
        if (this.dropdown.length) {
            const dropdownBtn = this.element.nativeElement.querySelector(".ap-field-dropdown-wrapper");
            const offsetWidth = dropdownBtn?.getBoundingClientRect().width
                ? `calc(100% - ${convertToRem(dropdownBtn?.getBoundingClientRect().width + convertToRelativePx(20))})`
                : "calc(100% - 5.5rem)";
            this.titleContainerRef.nativeElement.style.maxWidth = offsetWidth;
        }
        this.phoneTagEle = this.element.nativeElement.querySelector(".ap-field-dropdown-phone-tag");
        if (this.phoneTagEle) {
            const offsetPadding = this.phoneTagEle.getBoundingClientRect().width
                ? convertToRem(this.phoneTagEle.getBoundingClientRect().width + convertToRelativePx(2))
                : "2.3125rem";
            this.inputRef.element.nativeElement.style.paddingLeft =
                offsetPadding;
        }
    }
    setDatepickerDialog() {
        const fieldEle = this.element.nativeElement.querySelector(".ap-field");
        let dialog = this.attachedDOM && document.getElementById(this.dialogContainerId)
            ? document.getElementById(this.dialogContainerId)?.firstChild
            : this.datepickerRef.element.nativeElement.firstChild;
        let [alignY, alignX] = this.dpCalendarPosition.split("-");
        if (this.adaptivePosition && dialog) {
            let x = "right", y = "top";
            let spacingTop = 8;
            const inputRect = this.inputRef.element.nativeElement.getBoundingClientRect();
            let win = window, d = document, e = d.documentElement, g = d.getElementsByTagName("body")[0], w = win.innerWidth || e.clientWidth || g.clientWidth, h = win.innerHeight || e.clientHeight || g.clientHeight;
            const viewport = { width: w, height: h };
            const left = inputRect.right - dialog.offsetWidth, right = viewport.width - inputRect.left - dialog.offsetWidth, top = inputRect.top - dialog.offsetHeight, bottom = viewport.height - inputRect.bottom - dialog.offsetHeight;
            if (left > 0 || (right < 0 && left < 0)) {
                dialog.style.right = 0;
                dialog.style.left = "unset";
                x = "right";
            }
            else if (right > 0 && left < 0) {
                dialog.style.right = "unset";
                dialog.style.left = 0;
                x = "left";
            }
            if (bottom > 0 || (bottom < 0 && top < 0)) {
                dialog.style.top = "3.5rem";
                dialog.style.bottom = "unset";
                y = "top";
                alignY = "bottom";
                spacingTop = 8;
            }
            else if (top > 0 && bottom < 0) {
                dialog.style.top = "unset";
                dialog.style.bottom = "3.5rem";
                y = "bottom";
                alignY = "top";
                spacingTop = -8;
            }
            dialog.style["transform-origin"] = `${x} ${y}`;
            if (this.attachedDOM) {
                this.dialogService.setDialogStyles(fieldEle, dialog, {
                    alignDirection: `${alignY}-${x}`,
                    top: spacingTop,
                    left: 0,
                });
            }
        }
        else {
            if (dialog)
                this.dialogService.setDialogTransformOrigin(dialog, this.dpCalendarPosition);
            if (this.attachedDOM) {
                let spacingTop = 0, spacingLeft = 0;
                switch (alignY) {
                    case "top":
                        spacingTop = -8;
                        break;
                    case "bottom":
                        spacingTop = 8;
                        break;
                    case "left":
                        spacingLeft = -8;
                        break;
                    case "right":
                        spacingLeft = 8;
                        break;
                    default:
                        spacingTop = 0;
                        spacingLeft = 0;
                }
                if (dialog)
                    this.dialogService.setDialogStyles(fieldEle, dialog, {
                        alignDirection: this.dpCalendarPosition,
                        top: spacingTop,
                        left: spacingLeft,
                    });
            }
            else {
                let spacingX = 0, spacingY = 0;
                switch (alignY) {
                    case "top":
                    case "bottom":
                        spacingY = 8;
                        break;
                    case "left":
                    case "right":
                        spacingX = 8;
                        break;
                    default:
                        spacingX = 0;
                        spacingY = 0;
                }
                if (dialog)
                    this.dialogService.setFixedDialogStyle(fieldEle, dialog, {
                        alignDirection: this.dpCalendarPosition,
                        spacingY,
                        spacingX,
                    });
            }
        }
    }
    relocateDatepickerDialog() {
        const dialog = this.datepickerRef.element.nativeElement.firstChild;
        if (dialog) {
            this.dialogContainerId = this.dialogService.setDialogPosition(dialog, this.attachedDOM).dialogContainerId;
        }
    }
    /**
     * Compare two dates and get the difference in days/months/years.
     * @param day1 Date
     * @param day2 Date
     * @param granularity 0: day, 1: month, 2: year
     * @returns number of (day2 - day1)
     */
    getDatesDiff(day1, day2, granularity) {
        day1 = new Date(day1.getFullYear(), day1.getMonth(), day1.getDate());
        day2 = new Date(day2.getFullYear(), day2.getMonth(), day2.getDate());
        if (granularity === 0) {
            return (day2.getTime() - day1.getTime()) / (1000 * 60 * 60 * 24);
        }
        else if (granularity === 1) {
            let months;
            months = (day2.getFullYear() - day1.getFullYear()) * 12;
            months -= day1.getMonth();
            months += day2.getMonth();
            return months;
        }
        else if (granularity === 2) {
            return day2.getFullYear() - day1.getFullYear();
        }
        else {
            return 0;
        }
    }
    setCustomOptionsStyles() {
        if (!(this.optionsEles && this.optionsEles.length))
            return;
        this.dpOptions.forEach((option, i) => {
            // Set selected options
            if (this.dpSelectedDates.length === 2) {
                if (this.datepickerService.isSameDay(this.dpSelectedDates[0], option.dates[0], 0) === 0 &&
                    this.datepickerService.isSameDay(this.dpSelectedDates[1], option.dates[1], 0) === 0) {
                    this.optionsEles[i].classList.add("selected");
                }
            }
            // Set disabled options
            let startDate = option.dates[0], endDate = option.dates[1];
            while (this.datepickerService.isSameDay(startDate, endDate, 0) === 1) {
                if (!this.datepickerService.isDisabled(startDate, 0, this.isDisabledConfig)) {
                    this.optionsEles[i].setAttribute("tabindex", "0");
                    this.optionsEles[i].classList.remove("disabled");
                    break;
                }
                this.optionsEles[i].setAttribute("tabindex", "-1");
                this.optionsEles[i].classList.add("disabled");
                startDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 1);
            }
            if (this.datepickerService.isSameDay(startDate, endDate, 0) === 0) {
                if (!this.datepickerService.isDisabled(startDate, 0, this.isDisabledConfig)) {
                    this.optionsEles[i].setAttribute("tabindex", "0");
                    this.optionsEles[i].classList.remove("disabled");
                }
                else {
                    this.optionsEles[i].setAttribute("tabindex", "-1");
                    this.optionsEles[i].classList.add("disabled");
                }
            }
        });
    }
    relocateDatepickerOptions() {
        if (this.content) {
            let datepickerOptionsEle = this.content.nativeElement;
            const datepickerOptionsWrapperEle = this.attachedDOM
                ? this.datepickerRef.datepickerWrapperRef.nativeElement?.querySelector(".ap-datepicker-options-wrapper")
                : this.element.nativeElement.querySelector(".ap-datepicker-options-wrapper");
            if (datepickerOptionsWrapperEle) {
                while (datepickerOptionsEle.childNodes.length > 0) {
                    datepickerOptionsWrapperEle.appendChild(datepickerOptionsEle.childNodes[0]);
                }
                // datepickerOptionsWrapperEle.insertAdjacentHTML('beforeEnd', datepickerOptionsEle.innerHTML);
                this.content.nativeElement.remove();
                setTimeout(() => {
                    this.optionsEles = this.attachedDOM
                        ? this.datepickerRef.datepickerWrapperRef.nativeElement?.querySelectorAll(".ap-datepicker-options span")
                        : this.element.nativeElement.querySelectorAll(".ap-datepicker-options span");
                    this.setCustomOptionsStyles();
                });
            }
        }
    }
    setDatepickerPlaceholder() {
        if (this.inputRef &&
            !this.inputRef.element.nativeElement.hasAttribute("placeholder") &&
            !this.readonly) {
            // let placeholder = '';
            // if (this.dpView === 'date') {
            //   placeholder = this.dpRange ? `mm${this.dpDateSeparator}dd${this.dpDateSeparator}yyyy ${this.dpRangeConnectorFormat} mm${this.dpDateSeparator}dd${this.dpDateSeparator}yyyy` : `mm${this.dpDateSeparator}dd${this.dpDateSeparator}yyyy`;
            // } else if (this.dpView === 'month') {
            //   placeholder = this.dpRange ? `mm${this.dpDateSeparator}yyyy ${this.dpRangeConnectorFormat} mm${this.dpDateSeparator}yyyy` : `mm${this.dpDateSeparator}yyyy`;
            // } else if (this.dpView === 'year') {
            //   placeholder = this.dpRange ? `yyyy ${this.dpRangeConnectorFormat} yyyy` : `yyyy`;
            // }
            let placeholder = this.dpRange
                ? `${this.customFormatWithSeparator} ${this.dpRangeConnectorFormat} ${this.customFormatWithSeparator}`
                : this.customFormatWithSeparator;
            this.inputRef.element.nativeElement.setAttribute("placeholder", placeholder);
        }
    }
    onResizeEvent(event) {
        if (this.datepicker) {
            this.setDatepickerDialog();
        }
    }
    onScrollEvent(event) {
        if (this.datepicker) {
            this.setDatepickerDialog();
        }
    }
    ngOnInit() {
        this.dpRangeConnectorFormat = this.dpRangeConnecterFormat
            ? this.dpRangeConnecterFormat
            : this.dpRangeConnectorFormat;
        if (this.predefinedFormat[this.dpView].findIndex((format) => format === this.dpDateformat) >= 0) {
            this.customFormatWithSeparator = this.dpDateformat.replaceAll("/", this.dpDateSeparator);
        }
        else {
            this.customFormatWithSeparator = this.dpDateformat;
        }
        if (this.dpView === "date") {
            this.mergedDisableRanges =
                this.datepickerService.getMergedDisabledRange(0, {
                    disabledDates: this.dpDisabledDates,
                    disabledRanges: this.dpDisabledRanges,
                });
            this.isDisabledConfig = {
                mergedDisableRanges: this.mergedDisableRanges,
                minDate: this.dpMinDate,
                maxDate: this.dpMaxDate,
                disabledDays: this.dpDisabledDays,
            };
        }
        else {
            this.mergedDisableRanges =
                this.datepickerService.getMergedDisabledRange(1, {
                    disabledDates: this.dpDisabledDates,
                    disabledRanges: this.dpDisabledRanges,
                });
            this.isDisabledConfig = {
                mergedDisableRanges: this.mergedDisableRanges,
                minDate: this.dpMinDate,
                maxDate: this.dpMaxDate,
            };
        }
        // if (this.defaultNum && this.type === 'appkit-number') {
        //   this.onNumberChange.emit(this.fieldService.formatNum(this.defaultNum.toString(), this.format));
        // }
        this.apFieldContainerId =
            "fieldContiner" +
                String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
                String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
                Date.now();
    }
    ngOnChanges(changes) {
        if (this.datepicker) {
            if (changes?.dpMinDate ||
                changes?.dpMaxDate ||
                changes?.dpDisabledDates ||
                changes?.dpDisabledRanges ||
                changes?.dpDisabledDays) {
                if (this.dpView === "date") {
                    this.mergedDisableRanges =
                        this.datepickerService.getMergedDisabledRange(0, {
                            disabledDates: this.dpDisabledDates,
                            disabledRanges: this.dpDisabledRanges,
                        });
                    this.isDisabledConfig = {
                        mergedDisableRanges: this.mergedDisableRanges,
                        minDate: this.dpMinDate,
                        maxDate: this.dpMaxDate,
                        disabledDays: this.dpDisabledDays,
                    };
                }
                else {
                    this.mergedDisableRanges =
                        this.datepickerService.getMergedDisabledRange(1, {
                            disabledDates: this.dpDisabledDates,
                            disabledRanges: this.dpDisabledRanges,
                        });
                    this.isDisabledConfig = {
                        mergedDisableRanges: this.mergedDisableRanges,
                        minDate: this.dpMinDate,
                        maxDate: this.dpMaxDate,
                    };
                }
                if (this.dpSelectedDates.length) {
                    this.setCustomOptionsStyles();
                }
            }
            if (changes.dpOptions) {
                this.relocateDatepickerOptions();
            }
            if (changes.dpDateSeparator ||
                changes.dpRangeConnectorFormat ||
                changes.dpRangeConnecterFormat) {
                this.setDatepickerPlaceholder();
            }
        }
        // setTimeout(() => {
        this.updateProperties();
        // }, 0);
        this.cdr.detectChanges();
        this.cdr.markForCheck();
    }
    ngAfterViewInit() {
        if (!this.inputRef) {
            return;
        }
        if (this.datepicker) {
            this.setDatepickerPlaceholder();
            setTimeout(() => {
                if (this.attachedDOM) {
                    this.relocateDatepickerDialog();
                    this.setDatepickerDialog();
                }
                else {
                    this.setDatepickerDialog();
                }
                // Disable entering dates manually when the custom format is not in the predefined list.
                if (this.predefinedFormat[this.dpView].findIndex((format) => format === this.dpDateformat) < 0) {
                    this.editable = false;
                }
            });
            // this.setInputDateValue(this.dpSelectedDates);
            // this.updateFormValue();
            if (this.dpSelectedDates.length === 2) {
                let view = this.dpView === "year"
                    ? 2
                    : this.dpView === "month"
                        ? 1
                        : 0;
                if (this.datepickerService.isDisabled(this.dpSelectedDates[0], view, this.isDisabledConfig) ||
                    this.datepickerService.isDisabled(this.dpSelectedDates[1], view, this.isDisabledConfig)) {
                    setTimeout(() => {
                        this.dpError = true;
                        this.inputRef.element.nativeElement.setAttribute("aria-label", this.getAriaLabel("datepickerDisabledDateMessage"));
                        this.dpOnDateInvalid.emit({
                            value: this.inputRef.element.nativeElement.value,
                            invalid: true,
                        });
                        this.updateProperties();
                    });
                }
                else {
                    this.inputRef.element.nativeElement.removeAttribute("aria-label");
                    this.dpOnDateInvalid.emit({
                        value: this.inputRef.element.nativeElement.value,
                        invalid: false,
                    });
                }
            }
            setTimeout(() => {
                if (this.dpCustom) {
                    this.relocateDatepickerOptions();
                }
            }, 0);
        }
        this.inputRef.handleChange = (event) => {
            // setTimeout(() => {
            this.updateProperties();
            // }, 0);
            if (this.datepicker) {
                setTimeout(() => {
                    this.dpError = !this.validateDateValue(this.dateValue);
                    if (!this.dpError) {
                        let view = this.dpView === "year"
                            ? 2
                            : this.dpView === "month"
                                ? 1
                                : 0;
                        if (this.dpRange) {
                            let dateRange = [];
                            this.dateValue
                                .split("_ap_connector_")
                                .forEach((value, i) => {
                                dateRange[i] =
                                    this.convertSingleDateString(value);
                            });
                            let disabled1 = this.datepickerService.isDisabled(new Date(dateRange[0]), view, this.isDisabledConfig);
                            let disabled2 = this.datepickerService.isDisabled(new Date(dateRange[1]), view, this.isDisabledConfig);
                            let rangeResultDisabled = disabled1 || disabled2 ? true : false;
                            if (rangeResultDisabled) {
                                this.dpErrorType = "disabled date";
                            }
                            this.dpError = rangeResultDisabled;
                        }
                        else {
                            let dateFromatValue = this.convertSingleDateString(this.dateValue);
                            let resultDisabled = this.datepickerService.isDisabled(new Date(dateFromatValue), view, this.isDisabledConfig);
                            if (resultDisabled) {
                                this.dpErrorType = "disabled date";
                            }
                            this.dpError = resultDisabled;
                        }
                    }
                    if (this.dpError) {
                        // let format = this.dpView === 'date' ? `mm${this.dpDateSeparator}dd${this.dpDateSeparator}yyyy`
                        //   : this.dpView === 'month' ? `mm${this.dpDateSeparator}yyyy`
                        //     : `yyyy`;
                        let format = this.customFormatWithSeparator;
                        let msg = this.dpErrorType === "invalid date"
                            ? this.getAriaLabel('datepickerInvalidDateMessage')
                            : this.dpErrorType === "invalid format"
                                ? this.getAriaLabel('datepickerInvalidFormatMessage')?.replaceAll('{format}', format)
                                : this.dpErrorType === "disabled date"
                                    ? this.getAriaLabel('datepickerDisabledDateMessage')
                                    : "";
                        if (msg.length) {
                            this.inputRef.element.nativeElement.setAttribute("aria-label", msg);
                        }
                        this.dpOnDateInvalid.emit({
                            value: this.dateValue,
                            invalid: true,
                        });
                    }
                    else {
                        this.inputRef.element.nativeElement.removeAttribute("aria-label");
                        this.dpOnDateInvalid.emit({
                            value: this.dateValue,
                            invalid: false,
                        });
                    }
                    this.updateProperties();
                    if (this.dpRange &&
                        !this.dpError &&
                        this.dateValue !== "" &&
                        this.dateValue.indexOf("_ap_connector_") === -1) {
                        this.dateValue =
                            this.dateValue + "_ap_connector_" + this.dateValue;
                    }
                    this.dateValue = this.dpError
                        ? this.dateValue
                        : this.convertToDateString(this.dateValue);
                    // Add timestamp to trigger @Input change
                    this.dateTextInput = this.dpError
                        ? `Invalid Date@${new Date().getTime().toString()}`
                        : this.dateValue === ""
                            ? `Empty Date@${new Date().getTime().toString()}`
                            : `${this.dateValue}@${new Date()
                                .getTime()
                                .toString()}`;
                });
            }
            if (this.type === "appkit-number") {
                const value = this.fieldService.removeFormatInNumber(event.target.value, this.format);
                let formattedValue;
                if (!this.fieldService.isNumber(value)) {
                    if (value !== "" && this.number) {
                        formattedValue = this.fieldService.formatNum(this.number, this.format);
                    }
                    else {
                        formattedValue = "";
                        this.number = "";
                    }
                }
                else {
                    if (this.fieldService.isInMinMax(value, this.maxNum, this.minNum)) {
                        formattedValue = this.fieldService.formatNum(value, this.format);
                        this.number = value;
                    }
                    else {
                        formattedValue = this.fieldService.formatNum(this.fieldService.getClosestNumberValue(value, this.maxNum, this.minNum), this.format);
                        this.number = this.fieldService.getClosestNumberValue(value, this.maxNum, this.minNum);
                    }
                }
                this.updateFormValue(formattedValue, formattedValue);
            }
        };
        this.inputRef.handleInput = (event) => {
            // setTimeout(() => {
            this.updateProperties();
            // }, 0);
            if (this.datepicker) {
                this.onDatepickerInputChange(event);
                this.isValueEdited = true;
                this.closeDatepicker(event);
            }
            if (this.type === "appkit-number") {
                const value = this.fieldService.removeFormatInNumber(event.target.value, this.format);
                if (this.fieldService.isNumber(value)) {
                    // Set disabled state for input number
                    if (this.numberRef) {
                        if (this.fieldService.isNumber(value)) {
                            if ((this.maxNum || this.maxNum === 0) &&
                                Number(value) >= this.maxNum) {
                                this.numberRef.upDisabled = true;
                            }
                            else {
                                this.numberRef.upDisabled = false;
                            }
                            if ((this.minNum || this.minNum === 0) &&
                                Number(value) <= this.minNum) {
                                this.numberRef.downDisabled = true;
                            }
                            else {
                                this.numberRef.downDisabled = false;
                            }
                        }
                    }
                    const formattedValue = this.fieldService.formatNum(value, this.format);
                    event.target.value = formattedValue;
                }
            }
        };
        this.inputRef.handleFocus = (event) => {
            this.render.addClass(this.element.nativeElement.querySelector(".ap-field-wrapper"), "focus");
        };
        this.inputRef.handleBlur = (event) => {
            this.render.removeClass(this.element.nativeElement.querySelector(".ap-field-wrapper"), "focus");
        };
        this.inputRef.checkLength = () => {
            // setTimeout(() => {
            this.updateProperties();
            // }, 0);
        };
        // this.inputRef.setDisabled = (isDisabled: boolean) => {
        //   this.disabled = isDisabled;
        // };
        // this.inputRef.setValid = () => {
        //   if (this.datepicker) {
        //     let disabledDateValidator: boolean = this.dpError;
        //     let formatValidator: boolean = false;
        //     let initializationValidator: boolean = false;
        //     if (this.dateValue.indexOf('_ap_connector_') > -1) {
        //       formatValidator = !this.validateDateValue(this.dateValue);
        //     }
        //     if (this.isDisabled({ dateObj: this.dpSelectedDates[0] }, 0) || this.isDisabled({ dateObj: this.dpSelectedDates[1] }, 0)) {
        //       initializationValidator = true;
        //     }
        //     if (disabledDateValidator || formatValidator || initializationValidator) {
        //       return { invalid: true };
        //     } else {
        //       return null;
        //     }
        //   } else {
        //     if (this.dpError) {
        //       return { invalid: true };
        //     } else {
        //       return null;
        //     }
        //   }
        // };
        setTimeout(() => {
            this.updateProperties();
            this.hasTooltip =
                this.element.nativeElement.querySelector("[ap-tooltip]");
            this.setPadding();
            if (this.dropdown && this.dropdown.length) {
                // if (this.dropdownButton) {
                //     this.dropdownButton.nativeElement.setAttribute(
                //         "aria-activedescendant",
                //         ""
                //     );
                // }
                this.dropdownListItem.toArray().forEach((o) => {
                    o.onSelectItem.subscribe((event) => {
                        this.selectItem(event);
                        if (this.dropdown.length) {
                            const dropdownBtn = this.element.nativeElement.querySelector(".ap-field-dropdown-wrapper");
                            const offsetWidth = dropdownBtn.getBoundingClientRect().width
                                ? `calc(100% - ${convertToRem(dropdownBtn.getBoundingClientRect().width + convertToRelativePx(20))})`
                                : "calc(100% - 5.5rem)";
                            this.titleContainerRef.nativeElement.style.maxWidth =
                                offsetWidth;
                        }
                    });
                });
                if (this.selectedItem) {
                    this.dropdown.forEach((dropdownItem) => {
                        if (dropdownItem.label === this.selectedItem.label) {
                            dropdownItem.checked = true;
                        }
                        else {
                            delete dropdownItem.checked;
                        }
                    });
                }
            }
            if (this.revealer) {
                this.inputRef.element.nativeElement.type = this.type;
            }
        }, 0);
        // let node = this.element.nativeElement;
        // while (node.parentNode) {
        //   this.listener.push(this.render.listen(node, 'scroll', () => {
        //     if (this.dropdownRef) {
        //       this.setDropdownHeight();
        //     }
        //   }));
        //   node = node.parentNode;
        // }
    }
    ngOnDestroy() {
        if (this.attachedDOM) {
            this.dialogService.destroyDialogContainer(this.attachedDOM, this.dialogContainerId);
        }
    }
    getAriaLabel(labelKey) {
        return this.localizationConfig.translation.aria ? this.localizationConfig.translation.aria[labelKey] : null;
    }
    getLabel(labelKey) {
        return this.localizationConfig.translation ? this.localizationConfig.translation[labelKey] : null;
    }
    get _fieldDropdownButtonLabel() {
        let fieldDropdownButtonLabel = this.localizationConfig.translation.aria ? this.localizationConfig.translation.aria['fieldDropdownButtonLabel'] : null;
        return fieldDropdownButtonLabel.replaceAll('{title}', this.title);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FieldComponent, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i4.DialogService }, { token: i1.DatePipe }, { token: i5.DatepickerService }, { token: FieldService }, { token: i3.LocalizationConfig }, { token: i4.FocusIndicatorService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: FieldComponent, selector: "ap-field", inputs: { styleClass: "styleClass", style: "style", title: "title", error: "error", disabled: "disabled", selectedItem: "selectedItem", customImg: "customImg", img: "img", unit: "unit", type: "type", required: "required", readonly: "readonly", revealer: "revealer", hideTitleOnInput: "hideTitleOnInput", textReadonly: "textReadonly", dropdown: "dropdown", fieldId: "fieldId", attachedDOM: "attachedDOM", adaptivePosition: "adaptivePosition", minNum: "minNum", maxNum: "maxNum", ariaLabel: "ariaLabel", defaultNum: "defaultNum", format: "format", datepicker: "datepicker", editable: "editable", useCustomValidation: "useCustomValidation", disableOutsideClose: "disableOutsideClose", dpLanguage: "dpLanguage", dpRange: "dpRange", dpAutoClose: "dpAutoClose", dpCalendarPosition: "dpCalendarPosition", dpType: "dpType", dpCustom: "dpCustom", dpOptions: "dpOptions", dpMinDate: "dpMinDate", dpMaxDate: "dpMaxDate", dpDisabledDates: "dpDisabledDates", dpDisabledRanges: "dpDisabledRanges", dpDisabledDays: "dpDisabledDays", dpDateformat: "dpDateformat", dpDateSeparator: "dpDateSeparator", dpShowOtherMonths: "dpShowOtherMonths", dpRangeConnecterFormat: "dpRangeConnecterFormat", dpRangeConnectorFormat: "dpRangeConnectorFormat", dpFirstDayOfWeek: "dpFirstDayOfWeek", dpView: "dpView", dpSelectedDates: "dpSelectedDates" }, outputs: { onNumberChange: "onNumberChange", onKeydown: "onKeydown", onClick: "onClick", onClose: "onClose", onShow: "onShow", onClickOutside: "onClickOutside", onListItemFocus: "onListItemFocus", dpSelectedDatesChange: "dpSelectedDatesChange", dpOnDateInvalid: "dpOnDateInvalid", dpOnClickNavigators: "dpOnClickNavigators" }, host: { listeners: { "window:resize": "onResizeEvent($event)", "window:scroll": "onScrollEvent($event)" } }, providers: [{ provide: FIELD_COMPONENT, useExisting: FieldComponent }], queries: [{ propertyName: "inputRef", first: true, predicate: FieldDirective, descendants: true }, { propertyName: "clearTextRef", first: true, predicate: FieldCleanerComponent, descendants: true }, { propertyName: "numberRef", first: true, predicate: FieldNumberComponent, descendants: true }, { propertyName: "textCounterRef", first: true, predicate: FieldCounterComponent, descendants: true }, { propertyName: "dropdownListItem", predicate: ["dropdownListItem"] }], viewQueries: [{ propertyName: "dropdownButton", first: true, predicate: ["dropdownButton"], descendants: true }, { propertyName: "datepickerRef", first: true, predicate: ["datepickerRef"], descendants: true }, { propertyName: "titleContainerRef", first: true, predicate: ["titleContainerRef"], descendants: true }, { propertyName: "content", first: true, predicate: ["content"], descendants: true }, { propertyName: "options", predicate: ["option"], descendants: true }], usesOnChanges: true, ngImport: i0, template: `
        <div
            class="ap-field {{ styleClass }}"
            style="{{ style }}"
            [class.has-length]="hasLength"
            (keydown)="onToggleKeydown($event, 'field')"
            (mouseup)="mousedown($event)"
            (click)="click($event)"
            (clickOutside)="clickOutside($event)"
            [class.textarea]="checkTextarea()"
            [class.ap-field-tooltip]="hasTooltip"
            [class.error]="error || (!useCustomValidation && dpError)"
            [class.text-readonly]="textReadonly"
            [class.disabled]="disabled"
            [class.readonly]="readonly"
        >
            <div
                class="ap-field-container"
                id="{{ apFieldContainerId }}"
                [class.show]="show"
                [class.hide-title]="phoneTagEle ? false : hideTitleOnInput"
                [class.not-editable]="datepicker && !editable"
            >
                <div
                    #titleContainerRef
                    class="ap-field-title-container"
                    [class.required]="required"
                >
                    <label
                        class="ap-field-title"
                        [for]="'field-input-' + fieldId"
                        [attr.aria-owns]="'field-input-' + fieldId"
                        [id]="'field-input-label-' + fieldId"
                        [attr.aria-disabled]="disabled ? true : false"
                        >{{ title }}</label
                    >
                </div>
                <div class="ap-field-wrapper">
                    <ng-container
                        ><ng-content
                            select=".ap-field-dropdown-phone-tag"
                        ></ng-content
                    ></ng-container>
                    <ng-container *ngIf="inputRef && inputRef.element">
                        <ng-content select="[appkit-field]"></ng-content>
                    </ng-container>
                    <div
                        class="ap-field-dropdown-wrapper"
                        *ngIf="dropdown && dropdown.length"
                        (clickOutside)="onclickOut($event, false)"
                    >
                        <div
                            class="ap-field-dropdown-button-group"
                            #dropdownButton
                            [class.with-unit]="unit"
                            [attr.tabindex]="disabled || readonly ? -1 : 0"
                            (click)="toggleDropdown($event)"
                            (keydown)="onToggleKeydown($event, 'dropdown')"
                            role="button"
                            type="button"
                            [attr.aria-expanded]="show"
                            [attr.aria-controls]="'field-dropdown-' + fieldId"
                            [attr.aria-disabled]="
                                disabled || readonly ? true : false
                            "
                            [attr.aria-label]="_fieldDropdownButtonLabel"
                        >
                            <img
                                class="ap-field-img"
                                *ngIf="selectedItem && img && !customImg"
                                [src]="selectedItem.url"
                                [attr.aria-hidden]="true"
                            />
                            <div
                                class="ap-field-img"
                                *ngIf="selectedItem && img && customImg"
                                [attr.aria-hidden]="true"
                            >
                                <ng-content
                                    select=".ap-field-dropdown-custom-img"
                                ></ng-content>
                            </div>
                            <span
                                class="ap-field-unit"
                                *ngIf="selectedItem && unit"
                                [attr.aria-hidden]="true"
                                >{{ selectedItem.unit }}</span
                            >
                            <span
                                class="Appkit4-icon ap-field-icon-btn icon-down-chevron-outline"
                                [class.up]="show"
                                [class.with-unit]="unit"
                                [attr.aria-hidden]="true"
                            ></span>
                        </div>
                        <div
                            class="ap-field-dropdown"
                            role="listbox"
                            [id]="'field-dropdown-' + fieldId"
                            [attr.aria-labelledby]="
                                'field-input-label-' + fieldId
                            "
                        >
                            <ng-content
                                select="ap-dropdown-list-item"
                            ></ng-content>
                        </div>
                    </div>
                    <span
                        class="Appkit4-icon ap-field-icon-btn ap-field-password-reveal-icon"
                        *ngIf="revealer"
                        [class.icon-view-outline]="checkPassword()"
                        [class.icon-view-off-outline]="!checkPassword()"
                        [class.disabled]="!checkPasswordExist()"
                        (click)="toggleRevealer($event)"
                        (keydown)="onToggleKeydown($event, 'revealer')"
                        [tabindex]="
                            disabled || readonly || !checkPasswordExist()
                                ? -1
                                : 0
                        "
                        role="button"
                        type="button"
                        [attr.aria-disabled]="
                            disabled || readonly || !checkPasswordExist()
                                ? true
                                : false
                        "
                        [attr.aria-label]="
                            checkPassword()
                                ? getAriaLabel('revealPassword')
                                : getAriaLabel('unrevealPassword')
                        "
                    ></span>
                    <div class="ap-field-datepicker-wrapper" *ngIf="datepicker">
                        <span
                            class="Appkit4-icon icon-calendar-outline ap-field-icon-btn"
                            *ngIf="datepicker"
                            (click)="toggleDatepicker($event, true)"
                            (keydown)="onToggleKeydown($event, 'datepicker')"
                            [tabindex]="disabled ? -1 : 0"
                            role="button"
                            type="button"
                            [attr.aria-label]="getLabel('chooseDate')"
                            [attr.aria-controls]="'datepicker-' + fieldId"
                            [attr.aria-haspopup]="'dialog'"
                            [attr.aria-disabled]="
                                disabled || readonly ? true : false
                            "
                        ></span>
                        <div
                            class="ap-field-datepicker-dialog"
                            *ngIf="datepicker && dpView === 'date'"
                            ap-datepicker
                            #datepickerRef
                            [focusTrapEle]="focusTrapEle"
                            [fieldId]="fieldId"
                            [lang]="dpLanguage"
                            [(selectedDates)]="dpSelectedDates"
                            [range]="dpRange"
                            [type]="dpType"
                            [custom]="dpCustom"
                            [dateTextInput]="dateTextInput"
                            [optionsEles]="optionsEles"
                            [autoClose]="dpAutoClose"
                            [datepickerOptions]="dpOptions"
                            [(isValueEdited)]="isValueEdited"
                            [minDate]="dpMinDate"
                            [maxDate]="dpMaxDate"
                            [showOtherMonths]="dpShowOtherMonths"
                            [disabledDates]="dpDisabledDates"
                            [disabledRanges]="dpDisabledRanges"
                            [disabledDays]="dpDisabledDays"
                            [firstDayOfWeek]="dpFirstDayOfWeek"
                            (currentViewChange)="currentViewChange($event)"
                            (triggerTextInputChange)="textInputChange($event)"
                            (onDateChange)="dateChange($event)"
                            (onDateValidation)="validateDate($event)"
                            (onDatepickerClose)="closeDatepicker($event, true)"
                            (onClickNavigators)="onClickNavigators($event)"
                        ></div>
                        <div
                            class="ap-field-datepicker-dialog"
                            *ngIf="datepicker && dpView !== 'date'"
                            ap-month-year-picker
                            #datepickerRef
                            [focusTrapEle]="focusTrapEle"
                            [fieldId]="fieldId"
                            [lang]="dpLanguage"
                            [(selectedDates)]="dpSelectedDates"
                            [range]="dpRange"
                            [view]="dpView"
                            [dateTextInput]="dateTextInput"
                            [autoClose]="dpAutoClose"
                            [(isValueEdited)]="isValueEdited"
                            [minDate]="dpMinDate"
                            [maxDate]="dpMaxDate"
                            [disabledDates]="dpDisabledDates"
                            [disabledRanges]="dpDisabledRanges"
                            (currentViewChange)="currentViewChange($event)"
                            (triggerTextInputChange)="textInputChange($event)"
                            (onDateChange)="dateChange($event)"
                            (onDateValidation)="validateDate($event)"
                            (onDatepickerClose)="closeDatepicker($event, true)"
                            (onClickNavigators)="onClickNavigators($event)"
                        ></div>
                    </div>
                    <ng-container
                        ><ng-content
                            select="[ap-tooltip], ap-field-cleaner, ap-field-counter, ap-field-number"
                        ></ng-content
                    ></ng-container>
                </div>
                <!-- <div class="ap-field-placeholder-container" *ngIf="datepicker" [id]="'datepicker-format-'+fieldId" aria-hidden="true">
          <span class="ap-field-placeholder" *ngIf="dpView==='date'">mm{{dpDateSeparator}}dd{{dpDateSeparator}}yyyy<span *ngIf="dpRange"> {{dpRangeConnectorFormat}} mm{{dpDateSeparator}}dd{{dpDateSeparator}}yyyy</span></span>
          <span class="ap-field-placeholder" *ngIf="dpView==='month'">mm{{dpDateSeparator}}yyyy<span *ngIf="dpRange"> {{dpRangeConnectorFormat}} mm{{dpDateSeparator}}yyyy</span></span>
          <span class="ap-field-placeholder" *ngIf="dpView==='year'">yyyy<span *ngIf="dpRange"> {{dpRangeConnectorFormat}} yyyy</span></span>
        </div> -->
                <div
                    class="ap-field-datepicker-error-message-container"
                    *ngIf="datepicker && !useCustomValidation && dpError"
                >
                    <div
                        class="ap-field-datepicker-error-message"
                        [id]="'datepicker-error-message-' + fieldId"
                        aria-live="assertive"
                    >
                        {{dpRange ? getLabel('datepickerRangeErrorMessage') : getLabel('datepickerSingleErrorMessage')}}
                    </div>
                </div>
                <div #content class="ap-field-content">
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    `, isInline: true, styles: [":host ::ng-deep .ap-field .ap-field-container{position:relative;display:flex;flex-wrap:wrap;margin-bottom:0}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper{display:flex;height:3rem;width:100%;background-color:var(--color-background-container);border-radius:var(--border-radius-2);box-shadow:inset 0 0 0 .0625rem var(--color-background-border);overflow:hidden;transition:color .3s,background-color .3s,box-shadow .3s}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .icon-down-chevron-outline:before{transform:rotate(0);transition:transform .3s}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .icon-down-chevron-outline.up:before{transform:rotate(-180deg)}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .icon-up-chevron-outline.rotate{transform:rotate(-180deg)}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-input{letter-spacing:-.025rem;width:100%;color:var(--color-text-heading);-webkit-appearance:none;background-color:transparent;outline:0!important;transition:margin .3s,padding-bottom .3s,color .3s;border-width:0}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-input:-webkit-autofill{-webkit-background-clip:text;-webkit-text-fill-color:var(--color-text-body)}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper input{margin:var(--spacing-7) var(--spacing-3) 0;padding:0 0 .5625rem}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper input[type=password]::-webkit-contacts-auto-fill-button,:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper input[type=password]::-webkit-credentials-auto-fill-button,:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper input[type=password]::-ms-clear,:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper input[type=password]::-ms-reveal{display:none!important;visibility:hidden;pointer-events:none;height:0;width:0;margin:0}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper input[type=number]{-moz-appearance:textfield;appearance:textfield}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-icon-btn{position:absolute;right:var(--spacing-2);top:var(--spacing-2);width:2.5rem;height:2.5rem;line-height:2.5rem;color:var(--color-text-body);border-radius:var(--border-radius-1);transition:all .3s;cursor:pointer}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-icon-btn:not(.disabled):not(.icon-down-chevron-outline):hover{background-color:var(--color-background-hover-selected)}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-icon-btn.disabled{pointer-events:none;color:var(--color-text-disabled)}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-icon-btn.readonly{pointer-events:none}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-icon-btn:before{font-weight:var(--font-weight-2);height:1.5rem;width:1.5rem;line-height:1.5rem}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-dropdown-wrapper{display:flex;align-items:center;margin-right:var(--spacing-2)}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-dropdown-wrapper .ap-field-dropdown-button-group{display:flex;align-items:center;height:2.5rem;padding:var(--spacing-3);border-radius:var(--border-radius-1);transition:all .3s;cursor:pointer;z-index:1;color:var(--color-text-heading)}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-dropdown-wrapper .ap-field-dropdown-button-group:not(.disabled):hover{background-color:var(--color-background-hover-selected)}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-dropdown-wrapper .ap-field-dropdown-button-group.disabled{opacity:var(--opacity-3);pointer-events:none}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-dropdown-wrapper .ap-field-dropdown-button-group .ap-field-img{display:flex;align-items:center;justify-content:center;margin-right:var(--spacing-2);width:1.5rem;height:1.5rem;pointer-events:none;-webkit-user-select:none;user-select:none;transition:all .3s}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-dropdown-wrapper .ap-field-dropdown-button-group .ap-field-icon-btn{position:relative;top:auto;right:auto;width:1.5rem;height:1.5rem}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-dropdown-wrapper .ap-field-dropdown-button-group .ap-field-unit{margin-right:var(--spacing-1);line-height:1.5rem;pointer-events:none;-webkit-user-select:none;user-select:none}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-dropdown-wrapper .ap-field-dropdown{position:absolute;right:var(--spacing-3);top:calc(var(--spacing-8) - var(--spacing-3));width:17.5rem;padding:var(--spacing-3);border-radius:var(--border-radius-3);box-shadow:var(--box-shadow-3);background-color:var(--color-background-container);z-index:99;transition:visibility .3s,opacity .3s,transform .3s;overflow:auto}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-counter{position:absolute;top:var(--spacing-3);right:var(--spacing-3);height:.75rem;line-height:.75rem;font-size:.75rem;color:var(--color-text-light);transition:opacity .3s,color .3s;pointer-events:none}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-number{display:grid;position:absolute;right:var(--spacing-2);top:var(--spacing-2)}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-dropdown-phone-tag{position:absolute;left:var(--spacing-3);top:var(--spacing-7);height:1rem;line-height:1rem;-webkit-user-select:none;user-select:none;cursor:default;transition:all .3s;color:var(--color-text-heading)}:host ::ng-deep .ap-field .ap-field-container.hide-title input{margin:var(--spacing-4) var(--spacing-3);padding:0}:host ::ng-deep .ap-field .ap-field-container.hide-title textarea{margin-top:var(--spacing-5)!important}:host ::ng-deep .ap-field .ap-field-container .ap-field-datepicker-error-message-container{position:absolute;top:3rem;left:0}:host ::ng-deep .ap-field .ap-field-container .ap-field-datepicker-error-message-container .ap-field-datepicker-error-message{display:inline-block;margin:var(--spacing-3) var(--spacing-3) var(--spacing-4);color:var(--color-text-error);font-size:.75rem;height:.875rem}:host ::ng-deep .ap-field .ap-field-container .ap-field-content .ap-datepicker-options{display:none}:host ::ng-deep .ap-field .ap-field-container:not(.show) .ap-field-dropdown-wrapper .ap-field-dropdown{visibility:hidden;opacity:0;transform:translateY(var(--spacing-4))}:host ::ng-deep .ap-field .ap-field-title-container{position:absolute;left:var(--spacing-3);top:var(--spacing-4);max-width:calc(100% - var(--spacing-5));line-height:1.5rem;font-size:1rem;color:var(--color-text-light);transition:all .3s;pointer-events:none;z-index:1}:host ::ng-deep .ap-field .ap-field-title-container .ap-field-title{width:100%;display:inline-block;-webkit-user-select:none;user-select:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}:host ::ng-deep .ap-field .ap-field-title-container.required:before{content:\"\";position:absolute;right:calc(-1 * var(--spacing-3));top:var(--spacing-1);width:.25rem;height:.25rem;border-radius:var(--border-radius-1);background-color:var(--color-text-error);transition:all .3s}:host ::ng-deep .ap-field.has-length .ap-field-title-container,:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.text-readonly):focus-within .ap-field-container:not(.hide-title) .ap-field-title-container,:host ::ng-deep .ap-field:not(.readonly) .ap-field-container.open .ap-field-title-container,:host ::ng-deep .ap-field:not(.readonly) .ap-field-container.show .ap-field-title-container{position:absolute;left:var(--spacing-3);top:var(--spacing-3);max-width:calc(100% - var(--spacing-5));height:.875rem;line-height:.875rem;margin-top:-.0625rem;font-size:.75rem;color:var(--color-text-light);pointer-events:none}:host ::ng-deep .ap-field.has-length .ap-field-title-container.required:before,:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.text-readonly):focus-within .ap-field-container:not(.hide-title) .ap-field-title-container.required:before,:host ::ng-deep .ap-field:not(.readonly) .ap-field-container.open .ap-field-title-container.required:before,:host ::ng-deep .ap-field:not(.readonly) .ap-field-container.show .ap-field-title-container.required:before{content:\"\";position:absolute;right:calc(-1 * var(--spacing-3));top:var(--spacing-1);width:.25rem;height:.25rem;background-color:var(--color-text-error);border-radius:50%}:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.text-readonly):focus-within .hide-title .ap-field-title-container,:host ::ng-deep .ap-field:not(.readonly) .ap-field-container.show.hide-title .ap-field-title-container{transition:opacity 0s;left:var(--spacing-3);top:var(--spacing-4);max-width:calc(100% - var(--spacing-5));line-height:1.5rem;height:1.5rem;font-size:1rem}:host ::ng-deep .ap-field.has-length .ap-field-placeholder-container{position:absolute;opacity:0;visibility:hidden;transition:opacity .3s;transform:translateY(-.375rem)}:host ::ng-deep .ap-field.has-length .hide-title .ap-field-title-container{opacity:0;transition:none}:host ::ng-deep .ap-field:not(.has-length) .ap-field-container.hide-title input.ap-field-input::placeholder,:host ::ng-deep .ap-field:not(.has-length) .ap-field-container.hide-title textarea.ap-field-input::placeholder{color:transparent}:host ::ng-deep .ap-field:not(.has-length) .ap-field-container.hide-title input.ap-field-input::-webkit-input-placeholder,:host ::ng-deep .ap-field:not(.has-length) .ap-field-container.hide-title textarea.ap-field-input::-webkit-input-placeholder{color:transparent;-webkit-user-select:none;user-select:none}:host ::ng-deep .ap-field:not(.has-length) .ap-field-container.hide-title input.ap-field-input:-ms-input-placeholder,:host ::ng-deep .ap-field:not(.has-length) .ap-field-container.hide-title textarea.ap-field-input:-ms-input-placeholder{color:transparent}:host ::ng-deep .ap-field:not(.has-length) .ap-field-title-container{transition:all .3s}:host ::ng-deep .ap-field:not(.has-length) .ap-field-placeholder-container{position:absolute;opacity:0;visibility:hidden;pointer-events:none;left:var(--spacing-3);top:var(--spacing-7);transition:opacity .3s,transform .3s}:host ::ng-deep .ap-field:not(.has-length):not(.readonly) .ap-field-container.open .ap-field-placeholder-container,:host ::ng-deep .ap-field:not(.has-length):not(.readonly) .ap-field-container.show .ap-field-placeholder-container,:host ::ng-deep .ap-field:not(.has-length):focus-within .ap-field-container .ap-field-placeholder-container{opacity:1;visibility:visible;position:absolute;left:var(--spacing-3);top:1.875rem;max-width:calc(100% - var(--spacing-5) - 2.5rem);height:1.1875rem;line-height:1rem;font-size:1rem;color:var(--color-text-light);transition:opacity .3s,transform .3s;transform:translateY(-.375rem);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.hide-title) input.ap-field-input{margin-top:1.875rem;padding-bottom:.3125rem}:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.hide-title) input.ap-field-input::placeholder{color:transparent}:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.hide-title) input.ap-field-input::-webkit-input-placeholder{color:transparent;-webkit-user-select:none;user-select:none}:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.hide-title) input.ap-field-input:-ms-input-placeholder{color:transparent}:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.hide-title) textarea.ap-field-input{margin-top:2rem!important;margin-bottom:0!important}:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.hide-title) textarea.ap-field-input::placeholder{color:transparent}:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.hide-title) textarea.ap-field-input::-webkit-input-placeholder{color:transparent;-webkit-user-select:none;user-select:none}:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.hide-title) textarea.ap-field-input:-ms-input-placeholder{color:transparent}:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.show):not(.open) .icon-down-chevron-outline:not(.with-unit),:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.show):not(.open) .ap-field-password-reveal-icon,:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.show):not(.open) .icon-circle-delete-outline,:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.show):not(.open) .ap-field-img,:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.show):not(.open) .ap-field-icon,:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.show):not(.open) .ap-field-dropdown-phone-tag,:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.show):not(.open) .ap-field-counter,:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.show):not(.open) .ap-field-dropdown-button-group:not(.with-unit){transform:translateY(.25rem);opacity:0;visibility:hidden}:host ::ng-deep .ap-field.textarea .ap-field-container:after{content:\"\";position:absolute;right:.1875rem;bottom:.1875rem;width:.1875rem;height:.1875rem;border-radius:50%;background-color:var(--color-background-border);transition:background-color .3s,opacity .3s;pointer-events:none}:host ::ng-deep .ap-field.textarea .ap-field-container .ap-field-wrapper{height:auto}:host ::ng-deep .ap-field.textarea .ap-field-container .ap-field-wrapper textarea{margin:var(--spacing-7) 0 var(--spacing-3) var(--spacing-3);padding:0;height:5rem;min-height:1.5rem;line-height:1.25rem;resize:vertical;overflow-y:scroll}:host ::ng-deep .ap-field.textarea .ap-field-container .ap-field-wrapper textarea::-webkit-resizer{display:none}:host ::ng-deep .ap-field.textarea .ap-field-container .ap-field-wrapper textarea::-webkit-scrollbar{background-color:transparent;width:.5rem}:host ::ng-deep .ap-field.textarea .ap-field-container .ap-field-wrapper textarea::-webkit-scrollbar-corner{background-color:transparent}:host ::ng-deep .ap-field.textarea .ap-field-container .ap-field-wrapper textarea::-webkit-scrollbar-thumb{background-color:transparent}:host ::ng-deep .ap-field.textarea.disabled textarea{overflow:hidden!important}:host ::ng-deep .ap-field.textarea.readonly textarea{cursor:not-allowed}:host ::ng-deep .ap-field.textarea.error .ap-field-title-container{color:var(--color-text-body)!important}:host ::ng-deep .ap-field.textarea.error .ap-field-title-container .ap-field-title{color:var(--color-text-body)!important}:host ::ng-deep .ap-field.textarea.error .ap-field-wrapper .ap-field-counter{color:var(--color-text-body)!important}:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.text-readonly) .ap-field-wrapper:not(.as-toggle){cursor:text}:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.error) .ap-field-wrapper:hover{background-color:var(--color-background-hover)}:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.error):focus-within .ap-field-wrapper,:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.error) .ap-field-container.show .ap-field-wrapper,:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.error) .ap-field-container.open .ap-field-wrapper{box-shadow:inset 0 0 0 .0625rem var(--color-background-primary),0 0 0 .25rem rgba(var(--color-background-primary-rgb),var(--opacity-3))}:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.error):focus-within .ap-field-container:after,:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.error) .ap-field-container.show .ap-field-container:after,:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.error) .ap-field-container.open .ap-field-container:after{background-color:var(--color-background-primary)}:host ::ng-deep .ap-field:not(.disabled).error:focus-within .ap-field-wrapper,:host ::ng-deep .ap-field:not(.disabled).error .ap-field-container.show .ap-field-wrapper,:host ::ng-deep .ap-field:not(.disabled).error .ap-field-container.open .ap-field-wrapper{box-shadow:inset 0 0 0 .0625rem var(--color-background-danger),0 0 0 .25rem rgba(var(--color-background-danger-rgb),var(--opacity-3))}:host ::ng-deep .ap-field.error .ap-field-title-container{color:var(--color-text-body)!important}:host ::ng-deep .ap-field.error .ap-field-title-container .ap-field-title{color:var(--color-text-body)!important}:host ::ng-deep .ap-field.error .ap-field-wrapper{background-color:rgba(var(--color-background-danger-rgb),var(--opacity-3));box-shadow:inset 0 0 0 .0625rem var(--color-background-danger)}:host ::ng-deep .ap-field.error .ap-field-wrapper:not(.textarea).ap-field-input{color:var(--color-background-danger)}:host ::ng-deep .ap-field.error .ap-field-wrapper:not(.textarea).ap-field-input:-webkit-autofill{-webkit-text-fill-color:var(--color-background-danger)}:host ::ng-deep .ap-field.error .ap-field-wrapper .ap-field-icon-btn:not(.disabled):not(.icon-down-chevron-outline):hover{background-color:rgba(var(--color-background-danger-rgb),var(--opacity-3))!important}:host ::ng-deep .ap-field.error .ap-field-wrapper .ap-field-up:not(.disabled):hover,:host ::ng-deep .ap-field.error .ap-field-wrapper .ap-field-down:not(.disabled):hover{background-color:rgba(var(--color-background-danger-rgb),var(--opacity-3))!important}:host ::ng-deep .ap-field.error .ap-field-wrapper .ap-field-counter{color:var(--color-text-body)!important}:host ::ng-deep .ap-field.error .ap-field-title-container:not(.textarea).ap-field-title{color:var(--color-background-danger)}:host ::ng-deep .ap-field.error .ap-field-container:after{background-color:var(--color-background-danger)}:host ::ng-deep .ap-field.error .ap-field-number{color:var(--color-background-danger)}:host ::ng-deep .ap-field.disabled{cursor:not-allowed}:host ::ng-deep .ap-field.disabled .ap-field-container{pointer-events:none}:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-wrapper{box-shadow:inset 0 0 0 .0625rem rgba(var(--color-background-border-rgb))}:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-wrapper .ap-field-input{color:var(--color-text-disabled)}:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-title-container{color:var(--color-text-disabled)}:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-icon-btn,:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-password-reveal-icon:not(.disabled),:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-unit,:host ::ng-deep .ap-field.disabled .ap-field-container .icon-calendar-outline,:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-dropdown-phone-tag,:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-counter,:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-up,:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-down,:host ::ng-deep .ap-field.disabled .ap-field-container [ap-tooltip]{color:var(--color-text-disabled)}:host ::ng-deep .ap-field.disabled .ap-field-container:after{color:rgba(var(--color-background-border-rgb),var(--opacity-6))}:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-img{opacity:var(--opacity-3)}:host ::ng-deep .ap-field.readonly{cursor:not-allowed}:host ::ng-deep .ap-field.readonly:not(.textarea):not(.ap-field-tooltip) .ap-field-container{pointer-events:none}:host ::ng-deep .ap-field.readonly .ap-field-container .ap-field-wrapper{box-shadow:inset 0 0 0 .0625rem var(--color-background-border)}:host ::ng-deep .ap-field.readonly .ap-field-container .ap-field-wrapper .ap-field-input{pointer-events:none}:host ::ng-deep .ap-field.readonly .ap-field-container .ap-field-icon-btn[ap-tooltip]:hover{background-color:var(--color-background-hover)!important}:host ::ng-deep .ap-field.readonly:not(.has-length) .ap-field-container:not(.show) .ap-field-dropdown-phone-tag{transform:translateY(.375rem);opacity:0;visibility:hidden}:host ::ng-deep .ap-field.readonly:not(.has-length) .ap-field-container:not(.show) .ap-field-dropdown-phone-tag~.ap-field-dropdown-wrapper .ap-field-dropdown-button-group{opacity:0!important}:host ::ng-deep .ap-field.readonly:not(.has-length) .ap-field-container:not(.show) .ap-field-password-reveal-icon,:host ::ng-deep .ap-field.readonly:not(.has-length) .ap-field-container:not(.show) .ap-field-counter,:host ::ng-deep .ap-field.readonly:not(.has-length) .ap-field-container:not(.show) .ap-field-placeholder-container{opacity:0!important}:host ::ng-deep .ap-field.text-readonly .ap-field-wrapper{cursor:pointer}:host ::ng-deep .ap-field.text-readonly .ap-field-wrapper .ap-field-input{cursor:pointer;text-overflow:ellipsis;pointer-events:none}:host ::ng-deep .ap-field .ap-datepicker-wrapper{position:absolute;right:0;top:calc(var(--spacing-8) + var(--spacing-3));z-index:99;transition:visibility .3s,opacity .3s,transform .3s;transform-origin:top right}:host ::ng-deep .ap-field .ap-field-container:not(.open) .ap-datepicker-wrapper{visibility:hidden;opacity:0;transform:scale(.1)}::ng-deep .ap-dialog-container .ap-datepicker-wrapper{position:absolute;right:0;top:calc(var(--spacing-8) + var(--spacing-3));z-index:99;transition:visibility .3s,opacity .3s,transform .3s;transform-origin:top right}:host ::ng-deep .ap-field-cleaner.disabled{pointer-events:none}:host ::ng-deep .ap-field-cleaner.readonly{pointer-events:none}:host ::ng-deep .ap-field-up{width:2.5rem;height:1.25rem;line-height:1.25rem;border-radius:var(--border-radius-1);color:var(--color-text-body);cursor:pointer}:host ::ng-deep .ap-field-up.disabled{cursor:not-allowed}:host ::ng-deep .ap-field-up.readonly{display:none}:host ::ng-deep .ap-field-up:hover:not(.disabled):not(.readonly){background-color:var(--color-background-hover-selected)!important}:host ::ng-deep .ap-field-down{width:2.5rem;height:1.25rem;line-height:1.25rem;border-radius:var(--border-radius-1);color:var(--color-text-body);cursor:pointer}:host ::ng-deep .ap-field-down.disabled{cursor:not-allowed}:host ::ng-deep .ap-field-down.readonly{display:none}:host ::ng-deep .ap-field-down:hover:not(.disabled):not(.readonly){background-color:var(--color-background-hover-selected)!important}::ng-deep [data-keyboard-focus=true] .ap-field:not(.disabled):not(.readonly):not(.error):focus-within .ap-field-wrapper,::ng-deep [data-keyboard-focus=true] .ap-field:not(.disabled):not(.readonly):not(.error) .ap-field-container.show .ap-field-wrapper,::ng-deep [data-keyboard-focus=true] .ap-field:not(.disabled):not(.readonly):not(.error) .ap-field-container.open .ap-field-wrapper{box-shadow:inset 0 0 0 .0625rem var(--color-background-border)!important}::ng-deep [data-keyboard-focus=true] .ap-field:not(.disabled):not(.readonly):not(.error):focus-within .ap-field-wrapper.focus,::ng-deep [data-keyboard-focus=true] .ap-field:not(.disabled):not(.readonly):not(.error) .ap-field-container.show .ap-field-wrapper.focus,::ng-deep [data-keyboard-focus=true] .ap-field:not(.disabled):not(.readonly):not(.error) .ap-field-container.open .ap-field-wrapper.focus{outline:auto .125rem Highlight!important;outline:auto .3125rem -webkit-focus-ring-color!important;outline-offset:var(--spacing-1)}::ng-deep [data-keyboard-focus=true] .ap-field:not(.disabled).error:focus-within .ap-field-wrapper.focus,::ng-deep [data-keyboard-focus=true] .ap-field:not(.disabled).error .ap-field-container.show .ap-field-wrapper.focus,::ng-deep [data-keyboard-focus=true] .ap-field:not(.disabled).error .ap-field-container.open .ap-field-wrapper.focus{box-shadow:inset 0 0 0 .0625rem var(--color-background-border)!important;outline:auto .125rem Highlight!important;outline:auto .3125rem -webkit-focus-ring-color!important;outline-offset:var(--spacing-1)}::ng-deep [data-keyboard-focus=true] .ap-field.readonly .ap-field-container .ap-field-wrapper.focus{box-shadow:inset 0 0 0 .0625rem var(--color-background-border)!important;outline:auto .125rem Highlight;outline:auto .3125rem -webkit-focus-ring-color;outline-offset:var(--spacing-1)}::ng-deep .ap-field.error .ap-field-container .ap-field-wrapper .ap-field-dropdown-wrapper .ap-field-dropdown-button-group:not(.disabled):hover{background-color:rgba(var(--color-background-danger-rgb),var(--opacity-3))!important}\n"], dependencies: [{ kind: "directive", type: i0.forwardRef(() => i1.NgIf), selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i0.forwardRef(() => NgClickOutsideDirective), selector: "[clickOutside]", inputs: ["clickOutsideEnabled", "attachOutsideOnClick", "delayClickOutsideInit", "emitOnBlur", "exclude", "excludeBeforeClick", "clickOutsideEvents"], outputs: ["clickOutside"] }, { kind: "component", type: i0.forwardRef(() => i5.DatepickerComponent), selector: "ap-datepicker, [ap-datepicker]", inputs: ["styleClass", "style", "fieldId", "range", "dateTextInput", "autoClose", "inline", "type", "custom", "datepickerOptions", "minDate", "maxDate", "disabledDates", "disabledRanges", "disabledDays", "disabled", "showOtherMonths", "lang", "firstDayOfWeek", "selectedDates", "focusTrapEle", "optionsEles", "isValueEdited"], outputs: ["triggerTextInputChange", "onDatepickerClose", "onClickNavigators", "onDateChange", "onDateValidation", "currentViewChange", "selectedDatesChange", "isValueEditedChange"] }, { kind: "component", type: i0.forwardRef(() => i5.MonthYearPickerComponent), selector: "ap-month-year-picker, [ap-month-year-picker]", inputs: ["styleClass", "style", "fieldId", "range", "view", "dateTextInput", "autoClose", "inline", "minDate", "maxDate", "disabledDates", "disabledRanges", "disabled", "lang", "selectedDates", "focusTrapEle", "optionsEles", "isValueEdited"], outputs: ["triggerTextInputChange", "onDatepickerClose", "onClickNavigators", "onDateChange", "onDateValidation", "currentViewChange", "selectedDatesChange", "isValueEditedChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FieldComponent, decorators: [{
            type: Component,
            args: [{ selector: "ap-field", providers: [{ provide: FIELD_COMPONENT, useExisting: FieldComponent }], template: `
        <div
            class="ap-field {{ styleClass }}"
            style="{{ style }}"
            [class.has-length]="hasLength"
            (keydown)="onToggleKeydown($event, 'field')"
            (mouseup)="mousedown($event)"
            (click)="click($event)"
            (clickOutside)="clickOutside($event)"
            [class.textarea]="checkTextarea()"
            [class.ap-field-tooltip]="hasTooltip"
            [class.error]="error || (!useCustomValidation && dpError)"
            [class.text-readonly]="textReadonly"
            [class.disabled]="disabled"
            [class.readonly]="readonly"
        >
            <div
                class="ap-field-container"
                id="{{ apFieldContainerId }}"
                [class.show]="show"
                [class.hide-title]="phoneTagEle ? false : hideTitleOnInput"
                [class.not-editable]="datepicker && !editable"
            >
                <div
                    #titleContainerRef
                    class="ap-field-title-container"
                    [class.required]="required"
                >
                    <label
                        class="ap-field-title"
                        [for]="'field-input-' + fieldId"
                        [attr.aria-owns]="'field-input-' + fieldId"
                        [id]="'field-input-label-' + fieldId"
                        [attr.aria-disabled]="disabled ? true : false"
                        >{{ title }}</label
                    >
                </div>
                <div class="ap-field-wrapper">
                    <ng-container
                        ><ng-content
                            select=".ap-field-dropdown-phone-tag"
                        ></ng-content
                    ></ng-container>
                    <ng-container *ngIf="inputRef && inputRef.element">
                        <ng-content select="[appkit-field]"></ng-content>
                    </ng-container>
                    <div
                        class="ap-field-dropdown-wrapper"
                        *ngIf="dropdown && dropdown.length"
                        (clickOutside)="onclickOut($event, false)"
                    >
                        <div
                            class="ap-field-dropdown-button-group"
                            #dropdownButton
                            [class.with-unit]="unit"
                            [attr.tabindex]="disabled || readonly ? -1 : 0"
                            (click)="toggleDropdown($event)"
                            (keydown)="onToggleKeydown($event, 'dropdown')"
                            role="button"
                            type="button"
                            [attr.aria-expanded]="show"
                            [attr.aria-controls]="'field-dropdown-' + fieldId"
                            [attr.aria-disabled]="
                                disabled || readonly ? true : false
                            "
                            [attr.aria-label]="_fieldDropdownButtonLabel"
                        >
                            <img
                                class="ap-field-img"
                                *ngIf="selectedItem && img && !customImg"
                                [src]="selectedItem.url"
                                [attr.aria-hidden]="true"
                            />
                            <div
                                class="ap-field-img"
                                *ngIf="selectedItem && img && customImg"
                                [attr.aria-hidden]="true"
                            >
                                <ng-content
                                    select=".ap-field-dropdown-custom-img"
                                ></ng-content>
                            </div>
                            <span
                                class="ap-field-unit"
                                *ngIf="selectedItem && unit"
                                [attr.aria-hidden]="true"
                                >{{ selectedItem.unit }}</span
                            >
                            <span
                                class="Appkit4-icon ap-field-icon-btn icon-down-chevron-outline"
                                [class.up]="show"
                                [class.with-unit]="unit"
                                [attr.aria-hidden]="true"
                            ></span>
                        </div>
                        <div
                            class="ap-field-dropdown"
                            role="listbox"
                            [id]="'field-dropdown-' + fieldId"
                            [attr.aria-labelledby]="
                                'field-input-label-' + fieldId
                            "
                        >
                            <ng-content
                                select="ap-dropdown-list-item"
                            ></ng-content>
                        </div>
                    </div>
                    <span
                        class="Appkit4-icon ap-field-icon-btn ap-field-password-reveal-icon"
                        *ngIf="revealer"
                        [class.icon-view-outline]="checkPassword()"
                        [class.icon-view-off-outline]="!checkPassword()"
                        [class.disabled]="!checkPasswordExist()"
                        (click)="toggleRevealer($event)"
                        (keydown)="onToggleKeydown($event, 'revealer')"
                        [tabindex]="
                            disabled || readonly || !checkPasswordExist()
                                ? -1
                                : 0
                        "
                        role="button"
                        type="button"
                        [attr.aria-disabled]="
                            disabled || readonly || !checkPasswordExist()
                                ? true
                                : false
                        "
                        [attr.aria-label]="
                            checkPassword()
                                ? getAriaLabel('revealPassword')
                                : getAriaLabel('unrevealPassword')
                        "
                    ></span>
                    <div class="ap-field-datepicker-wrapper" *ngIf="datepicker">
                        <span
                            class="Appkit4-icon icon-calendar-outline ap-field-icon-btn"
                            *ngIf="datepicker"
                            (click)="toggleDatepicker($event, true)"
                            (keydown)="onToggleKeydown($event, 'datepicker')"
                            [tabindex]="disabled ? -1 : 0"
                            role="button"
                            type="button"
                            [attr.aria-label]="getLabel('chooseDate')"
                            [attr.aria-controls]="'datepicker-' + fieldId"
                            [attr.aria-haspopup]="'dialog'"
                            [attr.aria-disabled]="
                                disabled || readonly ? true : false
                            "
                        ></span>
                        <div
                            class="ap-field-datepicker-dialog"
                            *ngIf="datepicker && dpView === 'date'"
                            ap-datepicker
                            #datepickerRef
                            [focusTrapEle]="focusTrapEle"
                            [fieldId]="fieldId"
                            [lang]="dpLanguage"
                            [(selectedDates)]="dpSelectedDates"
                            [range]="dpRange"
                            [type]="dpType"
                            [custom]="dpCustom"
                            [dateTextInput]="dateTextInput"
                            [optionsEles]="optionsEles"
                            [autoClose]="dpAutoClose"
                            [datepickerOptions]="dpOptions"
                            [(isValueEdited)]="isValueEdited"
                            [minDate]="dpMinDate"
                            [maxDate]="dpMaxDate"
                            [showOtherMonths]="dpShowOtherMonths"
                            [disabledDates]="dpDisabledDates"
                            [disabledRanges]="dpDisabledRanges"
                            [disabledDays]="dpDisabledDays"
                            [firstDayOfWeek]="dpFirstDayOfWeek"
                            (currentViewChange)="currentViewChange($event)"
                            (triggerTextInputChange)="textInputChange($event)"
                            (onDateChange)="dateChange($event)"
                            (onDateValidation)="validateDate($event)"
                            (onDatepickerClose)="closeDatepicker($event, true)"
                            (onClickNavigators)="onClickNavigators($event)"
                        ></div>
                        <div
                            class="ap-field-datepicker-dialog"
                            *ngIf="datepicker && dpView !== 'date'"
                            ap-month-year-picker
                            #datepickerRef
                            [focusTrapEle]="focusTrapEle"
                            [fieldId]="fieldId"
                            [lang]="dpLanguage"
                            [(selectedDates)]="dpSelectedDates"
                            [range]="dpRange"
                            [view]="dpView"
                            [dateTextInput]="dateTextInput"
                            [autoClose]="dpAutoClose"
                            [(isValueEdited)]="isValueEdited"
                            [minDate]="dpMinDate"
                            [maxDate]="dpMaxDate"
                            [disabledDates]="dpDisabledDates"
                            [disabledRanges]="dpDisabledRanges"
                            (currentViewChange)="currentViewChange($event)"
                            (triggerTextInputChange)="textInputChange($event)"
                            (onDateChange)="dateChange($event)"
                            (onDateValidation)="validateDate($event)"
                            (onDatepickerClose)="closeDatepicker($event, true)"
                            (onClickNavigators)="onClickNavigators($event)"
                        ></div>
                    </div>
                    <ng-container
                        ><ng-content
                            select="[ap-tooltip], ap-field-cleaner, ap-field-counter, ap-field-number"
                        ></ng-content
                    ></ng-container>
                </div>
                <!-- <div class="ap-field-placeholder-container" *ngIf="datepicker" [id]="'datepicker-format-'+fieldId" aria-hidden="true">
          <span class="ap-field-placeholder" *ngIf="dpView==='date'">mm{{dpDateSeparator}}dd{{dpDateSeparator}}yyyy<span *ngIf="dpRange"> {{dpRangeConnectorFormat}} mm{{dpDateSeparator}}dd{{dpDateSeparator}}yyyy</span></span>
          <span class="ap-field-placeholder" *ngIf="dpView==='month'">mm{{dpDateSeparator}}yyyy<span *ngIf="dpRange"> {{dpRangeConnectorFormat}} mm{{dpDateSeparator}}yyyy</span></span>
          <span class="ap-field-placeholder" *ngIf="dpView==='year'">yyyy<span *ngIf="dpRange"> {{dpRangeConnectorFormat}} yyyy</span></span>
        </div> -->
                <div
                    class="ap-field-datepicker-error-message-container"
                    *ngIf="datepicker && !useCustomValidation && dpError"
                >
                    <div
                        class="ap-field-datepicker-error-message"
                        [id]="'datepicker-error-message-' + fieldId"
                        aria-live="assertive"
                    >
                        {{dpRange ? getLabel('datepickerRangeErrorMessage') : getLabel('datepickerSingleErrorMessage')}}
                    </div>
                </div>
                <div #content class="ap-field-content">
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    `, styles: [":host ::ng-deep .ap-field .ap-field-container{position:relative;display:flex;flex-wrap:wrap;margin-bottom:0}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper{display:flex;height:3rem;width:100%;background-color:var(--color-background-container);border-radius:var(--border-radius-2);box-shadow:inset 0 0 0 .0625rem var(--color-background-border);overflow:hidden;transition:color .3s,background-color .3s,box-shadow .3s}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .icon-down-chevron-outline:before{transform:rotate(0);transition:transform .3s}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .icon-down-chevron-outline.up:before{transform:rotate(-180deg)}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .icon-up-chevron-outline.rotate{transform:rotate(-180deg)}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-input{letter-spacing:-.025rem;width:100%;color:var(--color-text-heading);-webkit-appearance:none;background-color:transparent;outline:0!important;transition:margin .3s,padding-bottom .3s,color .3s;border-width:0}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-input:-webkit-autofill{-webkit-background-clip:text;-webkit-text-fill-color:var(--color-text-body)}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper input{margin:var(--spacing-7) var(--spacing-3) 0;padding:0 0 .5625rem}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper input[type=password]::-webkit-contacts-auto-fill-button,:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper input[type=password]::-webkit-credentials-auto-fill-button,:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper input[type=password]::-ms-clear,:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper input[type=password]::-ms-reveal{display:none!important;visibility:hidden;pointer-events:none;height:0;width:0;margin:0}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper input[type=number]{-moz-appearance:textfield;appearance:textfield}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-icon-btn{position:absolute;right:var(--spacing-2);top:var(--spacing-2);width:2.5rem;height:2.5rem;line-height:2.5rem;color:var(--color-text-body);border-radius:var(--border-radius-1);transition:all .3s;cursor:pointer}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-icon-btn:not(.disabled):not(.icon-down-chevron-outline):hover{background-color:var(--color-background-hover-selected)}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-icon-btn.disabled{pointer-events:none;color:var(--color-text-disabled)}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-icon-btn.readonly{pointer-events:none}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-icon-btn:before{font-weight:var(--font-weight-2);height:1.5rem;width:1.5rem;line-height:1.5rem}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-dropdown-wrapper{display:flex;align-items:center;margin-right:var(--spacing-2)}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-dropdown-wrapper .ap-field-dropdown-button-group{display:flex;align-items:center;height:2.5rem;padding:var(--spacing-3);border-radius:var(--border-radius-1);transition:all .3s;cursor:pointer;z-index:1;color:var(--color-text-heading)}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-dropdown-wrapper .ap-field-dropdown-button-group:not(.disabled):hover{background-color:var(--color-background-hover-selected)}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-dropdown-wrapper .ap-field-dropdown-button-group.disabled{opacity:var(--opacity-3);pointer-events:none}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-dropdown-wrapper .ap-field-dropdown-button-group .ap-field-img{display:flex;align-items:center;justify-content:center;margin-right:var(--spacing-2);width:1.5rem;height:1.5rem;pointer-events:none;-webkit-user-select:none;user-select:none;transition:all .3s}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-dropdown-wrapper .ap-field-dropdown-button-group .ap-field-icon-btn{position:relative;top:auto;right:auto;width:1.5rem;height:1.5rem}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-dropdown-wrapper .ap-field-dropdown-button-group .ap-field-unit{margin-right:var(--spacing-1);line-height:1.5rem;pointer-events:none;-webkit-user-select:none;user-select:none}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-dropdown-wrapper .ap-field-dropdown{position:absolute;right:var(--spacing-3);top:calc(var(--spacing-8) - var(--spacing-3));width:17.5rem;padding:var(--spacing-3);border-radius:var(--border-radius-3);box-shadow:var(--box-shadow-3);background-color:var(--color-background-container);z-index:99;transition:visibility .3s,opacity .3s,transform .3s;overflow:auto}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-counter{position:absolute;top:var(--spacing-3);right:var(--spacing-3);height:.75rem;line-height:.75rem;font-size:.75rem;color:var(--color-text-light);transition:opacity .3s,color .3s;pointer-events:none}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-number{display:grid;position:absolute;right:var(--spacing-2);top:var(--spacing-2)}:host ::ng-deep .ap-field .ap-field-container .ap-field-wrapper .ap-field-dropdown-phone-tag{position:absolute;left:var(--spacing-3);top:var(--spacing-7);height:1rem;line-height:1rem;-webkit-user-select:none;user-select:none;cursor:default;transition:all .3s;color:var(--color-text-heading)}:host ::ng-deep .ap-field .ap-field-container.hide-title input{margin:var(--spacing-4) var(--spacing-3);padding:0}:host ::ng-deep .ap-field .ap-field-container.hide-title textarea{margin-top:var(--spacing-5)!important}:host ::ng-deep .ap-field .ap-field-container .ap-field-datepicker-error-message-container{position:absolute;top:3rem;left:0}:host ::ng-deep .ap-field .ap-field-container .ap-field-datepicker-error-message-container .ap-field-datepicker-error-message{display:inline-block;margin:var(--spacing-3) var(--spacing-3) var(--spacing-4);color:var(--color-text-error);font-size:.75rem;height:.875rem}:host ::ng-deep .ap-field .ap-field-container .ap-field-content .ap-datepicker-options{display:none}:host ::ng-deep .ap-field .ap-field-container:not(.show) .ap-field-dropdown-wrapper .ap-field-dropdown{visibility:hidden;opacity:0;transform:translateY(var(--spacing-4))}:host ::ng-deep .ap-field .ap-field-title-container{position:absolute;left:var(--spacing-3);top:var(--spacing-4);max-width:calc(100% - var(--spacing-5));line-height:1.5rem;font-size:1rem;color:var(--color-text-light);transition:all .3s;pointer-events:none;z-index:1}:host ::ng-deep .ap-field .ap-field-title-container .ap-field-title{width:100%;display:inline-block;-webkit-user-select:none;user-select:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}:host ::ng-deep .ap-field .ap-field-title-container.required:before{content:\"\";position:absolute;right:calc(-1 * var(--spacing-3));top:var(--spacing-1);width:.25rem;height:.25rem;border-radius:var(--border-radius-1);background-color:var(--color-text-error);transition:all .3s}:host ::ng-deep .ap-field.has-length .ap-field-title-container,:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.text-readonly):focus-within .ap-field-container:not(.hide-title) .ap-field-title-container,:host ::ng-deep .ap-field:not(.readonly) .ap-field-container.open .ap-field-title-container,:host ::ng-deep .ap-field:not(.readonly) .ap-field-container.show .ap-field-title-container{position:absolute;left:var(--spacing-3);top:var(--spacing-3);max-width:calc(100% - var(--spacing-5));height:.875rem;line-height:.875rem;margin-top:-.0625rem;font-size:.75rem;color:var(--color-text-light);pointer-events:none}:host ::ng-deep .ap-field.has-length .ap-field-title-container.required:before,:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.text-readonly):focus-within .ap-field-container:not(.hide-title) .ap-field-title-container.required:before,:host ::ng-deep .ap-field:not(.readonly) .ap-field-container.open .ap-field-title-container.required:before,:host ::ng-deep .ap-field:not(.readonly) .ap-field-container.show .ap-field-title-container.required:before{content:\"\";position:absolute;right:calc(-1 * var(--spacing-3));top:var(--spacing-1);width:.25rem;height:.25rem;background-color:var(--color-text-error);border-radius:50%}:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.text-readonly):focus-within .hide-title .ap-field-title-container,:host ::ng-deep .ap-field:not(.readonly) .ap-field-container.show.hide-title .ap-field-title-container{transition:opacity 0s;left:var(--spacing-3);top:var(--spacing-4);max-width:calc(100% - var(--spacing-5));line-height:1.5rem;height:1.5rem;font-size:1rem}:host ::ng-deep .ap-field.has-length .ap-field-placeholder-container{position:absolute;opacity:0;visibility:hidden;transition:opacity .3s;transform:translateY(-.375rem)}:host ::ng-deep .ap-field.has-length .hide-title .ap-field-title-container{opacity:0;transition:none}:host ::ng-deep .ap-field:not(.has-length) .ap-field-container.hide-title input.ap-field-input::placeholder,:host ::ng-deep .ap-field:not(.has-length) .ap-field-container.hide-title textarea.ap-field-input::placeholder{color:transparent}:host ::ng-deep .ap-field:not(.has-length) .ap-field-container.hide-title input.ap-field-input::-webkit-input-placeholder,:host ::ng-deep .ap-field:not(.has-length) .ap-field-container.hide-title textarea.ap-field-input::-webkit-input-placeholder{color:transparent;-webkit-user-select:none;user-select:none}:host ::ng-deep .ap-field:not(.has-length) .ap-field-container.hide-title input.ap-field-input:-ms-input-placeholder,:host ::ng-deep .ap-field:not(.has-length) .ap-field-container.hide-title textarea.ap-field-input:-ms-input-placeholder{color:transparent}:host ::ng-deep .ap-field:not(.has-length) .ap-field-title-container{transition:all .3s}:host ::ng-deep .ap-field:not(.has-length) .ap-field-placeholder-container{position:absolute;opacity:0;visibility:hidden;pointer-events:none;left:var(--spacing-3);top:var(--spacing-7);transition:opacity .3s,transform .3s}:host ::ng-deep .ap-field:not(.has-length):not(.readonly) .ap-field-container.open .ap-field-placeholder-container,:host ::ng-deep .ap-field:not(.has-length):not(.readonly) .ap-field-container.show .ap-field-placeholder-container,:host ::ng-deep .ap-field:not(.has-length):focus-within .ap-field-container .ap-field-placeholder-container{opacity:1;visibility:visible;position:absolute;left:var(--spacing-3);top:1.875rem;max-width:calc(100% - var(--spacing-5) - 2.5rem);height:1.1875rem;line-height:1rem;font-size:1rem;color:var(--color-text-light);transition:opacity .3s,transform .3s;transform:translateY(-.375rem);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.hide-title) input.ap-field-input{margin-top:1.875rem;padding-bottom:.3125rem}:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.hide-title) input.ap-field-input::placeholder{color:transparent}:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.hide-title) input.ap-field-input::-webkit-input-placeholder{color:transparent;-webkit-user-select:none;user-select:none}:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.hide-title) input.ap-field-input:-ms-input-placeholder{color:transparent}:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.hide-title) textarea.ap-field-input{margin-top:2rem!important;margin-bottom:0!important}:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.hide-title) textarea.ap-field-input::placeholder{color:transparent}:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.hide-title) textarea.ap-field-input::-webkit-input-placeholder{color:transparent;-webkit-user-select:none;user-select:none}:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.hide-title) textarea.ap-field-input:-ms-input-placeholder{color:transparent}:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.show):not(.open) .icon-down-chevron-outline:not(.with-unit),:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.show):not(.open) .ap-field-password-reveal-icon,:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.show):not(.open) .icon-circle-delete-outline,:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.show):not(.open) .ap-field-img,:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.show):not(.open) .ap-field-icon,:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.show):not(.open) .ap-field-dropdown-phone-tag,:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.show):not(.open) .ap-field-counter,:host ::ng-deep .ap-field:not(.has-length):not(:focus-within) .ap-field-container:not(.show):not(.open) .ap-field-dropdown-button-group:not(.with-unit){transform:translateY(.25rem);opacity:0;visibility:hidden}:host ::ng-deep .ap-field.textarea .ap-field-container:after{content:\"\";position:absolute;right:.1875rem;bottom:.1875rem;width:.1875rem;height:.1875rem;border-radius:50%;background-color:var(--color-background-border);transition:background-color .3s,opacity .3s;pointer-events:none}:host ::ng-deep .ap-field.textarea .ap-field-container .ap-field-wrapper{height:auto}:host ::ng-deep .ap-field.textarea .ap-field-container .ap-field-wrapper textarea{margin:var(--spacing-7) 0 var(--spacing-3) var(--spacing-3);padding:0;height:5rem;min-height:1.5rem;line-height:1.25rem;resize:vertical;overflow-y:scroll}:host ::ng-deep .ap-field.textarea .ap-field-container .ap-field-wrapper textarea::-webkit-resizer{display:none}:host ::ng-deep .ap-field.textarea .ap-field-container .ap-field-wrapper textarea::-webkit-scrollbar{background-color:transparent;width:.5rem}:host ::ng-deep .ap-field.textarea .ap-field-container .ap-field-wrapper textarea::-webkit-scrollbar-corner{background-color:transparent}:host ::ng-deep .ap-field.textarea .ap-field-container .ap-field-wrapper textarea::-webkit-scrollbar-thumb{background-color:transparent}:host ::ng-deep .ap-field.textarea.disabled textarea{overflow:hidden!important}:host ::ng-deep .ap-field.textarea.readonly textarea{cursor:not-allowed}:host ::ng-deep .ap-field.textarea.error .ap-field-title-container{color:var(--color-text-body)!important}:host ::ng-deep .ap-field.textarea.error .ap-field-title-container .ap-field-title{color:var(--color-text-body)!important}:host ::ng-deep .ap-field.textarea.error .ap-field-wrapper .ap-field-counter{color:var(--color-text-body)!important}:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.text-readonly) .ap-field-wrapper:not(.as-toggle){cursor:text}:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.error) .ap-field-wrapper:hover{background-color:var(--color-background-hover)}:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.error):focus-within .ap-field-wrapper,:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.error) .ap-field-container.show .ap-field-wrapper,:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.error) .ap-field-container.open .ap-field-wrapper{box-shadow:inset 0 0 0 .0625rem var(--color-background-primary),0 0 0 .25rem rgba(var(--color-background-primary-rgb),var(--opacity-3))}:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.error):focus-within .ap-field-container:after,:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.error) .ap-field-container.show .ap-field-container:after,:host ::ng-deep .ap-field:not(.disabled):not(.readonly):not(.error) .ap-field-container.open .ap-field-container:after{background-color:var(--color-background-primary)}:host ::ng-deep .ap-field:not(.disabled).error:focus-within .ap-field-wrapper,:host ::ng-deep .ap-field:not(.disabled).error .ap-field-container.show .ap-field-wrapper,:host ::ng-deep .ap-field:not(.disabled).error .ap-field-container.open .ap-field-wrapper{box-shadow:inset 0 0 0 .0625rem var(--color-background-danger),0 0 0 .25rem rgba(var(--color-background-danger-rgb),var(--opacity-3))}:host ::ng-deep .ap-field.error .ap-field-title-container{color:var(--color-text-body)!important}:host ::ng-deep .ap-field.error .ap-field-title-container .ap-field-title{color:var(--color-text-body)!important}:host ::ng-deep .ap-field.error .ap-field-wrapper{background-color:rgba(var(--color-background-danger-rgb),var(--opacity-3));box-shadow:inset 0 0 0 .0625rem var(--color-background-danger)}:host ::ng-deep .ap-field.error .ap-field-wrapper:not(.textarea).ap-field-input{color:var(--color-background-danger)}:host ::ng-deep .ap-field.error .ap-field-wrapper:not(.textarea).ap-field-input:-webkit-autofill{-webkit-text-fill-color:var(--color-background-danger)}:host ::ng-deep .ap-field.error .ap-field-wrapper .ap-field-icon-btn:not(.disabled):not(.icon-down-chevron-outline):hover{background-color:rgba(var(--color-background-danger-rgb),var(--opacity-3))!important}:host ::ng-deep .ap-field.error .ap-field-wrapper .ap-field-up:not(.disabled):hover,:host ::ng-deep .ap-field.error .ap-field-wrapper .ap-field-down:not(.disabled):hover{background-color:rgba(var(--color-background-danger-rgb),var(--opacity-3))!important}:host ::ng-deep .ap-field.error .ap-field-wrapper .ap-field-counter{color:var(--color-text-body)!important}:host ::ng-deep .ap-field.error .ap-field-title-container:not(.textarea).ap-field-title{color:var(--color-background-danger)}:host ::ng-deep .ap-field.error .ap-field-container:after{background-color:var(--color-background-danger)}:host ::ng-deep .ap-field.error .ap-field-number{color:var(--color-background-danger)}:host ::ng-deep .ap-field.disabled{cursor:not-allowed}:host ::ng-deep .ap-field.disabled .ap-field-container{pointer-events:none}:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-wrapper{box-shadow:inset 0 0 0 .0625rem rgba(var(--color-background-border-rgb))}:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-wrapper .ap-field-input{color:var(--color-text-disabled)}:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-title-container{color:var(--color-text-disabled)}:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-icon-btn,:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-password-reveal-icon:not(.disabled),:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-unit,:host ::ng-deep .ap-field.disabled .ap-field-container .icon-calendar-outline,:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-dropdown-phone-tag,:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-counter,:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-up,:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-down,:host ::ng-deep .ap-field.disabled .ap-field-container [ap-tooltip]{color:var(--color-text-disabled)}:host ::ng-deep .ap-field.disabled .ap-field-container:after{color:rgba(var(--color-background-border-rgb),var(--opacity-6))}:host ::ng-deep .ap-field.disabled .ap-field-container .ap-field-img{opacity:var(--opacity-3)}:host ::ng-deep .ap-field.readonly{cursor:not-allowed}:host ::ng-deep .ap-field.readonly:not(.textarea):not(.ap-field-tooltip) .ap-field-container{pointer-events:none}:host ::ng-deep .ap-field.readonly .ap-field-container .ap-field-wrapper{box-shadow:inset 0 0 0 .0625rem var(--color-background-border)}:host ::ng-deep .ap-field.readonly .ap-field-container .ap-field-wrapper .ap-field-input{pointer-events:none}:host ::ng-deep .ap-field.readonly .ap-field-container .ap-field-icon-btn[ap-tooltip]:hover{background-color:var(--color-background-hover)!important}:host ::ng-deep .ap-field.readonly:not(.has-length) .ap-field-container:not(.show) .ap-field-dropdown-phone-tag{transform:translateY(.375rem);opacity:0;visibility:hidden}:host ::ng-deep .ap-field.readonly:not(.has-length) .ap-field-container:not(.show) .ap-field-dropdown-phone-tag~.ap-field-dropdown-wrapper .ap-field-dropdown-button-group{opacity:0!important}:host ::ng-deep .ap-field.readonly:not(.has-length) .ap-field-container:not(.show) .ap-field-password-reveal-icon,:host ::ng-deep .ap-field.readonly:not(.has-length) .ap-field-container:not(.show) .ap-field-counter,:host ::ng-deep .ap-field.readonly:not(.has-length) .ap-field-container:not(.show) .ap-field-placeholder-container{opacity:0!important}:host ::ng-deep .ap-field.text-readonly .ap-field-wrapper{cursor:pointer}:host ::ng-deep .ap-field.text-readonly .ap-field-wrapper .ap-field-input{cursor:pointer;text-overflow:ellipsis;pointer-events:none}:host ::ng-deep .ap-field .ap-datepicker-wrapper{position:absolute;right:0;top:calc(var(--spacing-8) + var(--spacing-3));z-index:99;transition:visibility .3s,opacity .3s,transform .3s;transform-origin:top right}:host ::ng-deep .ap-field .ap-field-container:not(.open) .ap-datepicker-wrapper{visibility:hidden;opacity:0;transform:scale(.1)}::ng-deep .ap-dialog-container .ap-datepicker-wrapper{position:absolute;right:0;top:calc(var(--spacing-8) + var(--spacing-3));z-index:99;transition:visibility .3s,opacity .3s,transform .3s;transform-origin:top right}:host ::ng-deep .ap-field-cleaner.disabled{pointer-events:none}:host ::ng-deep .ap-field-cleaner.readonly{pointer-events:none}:host ::ng-deep .ap-field-up{width:2.5rem;height:1.25rem;line-height:1.25rem;border-radius:var(--border-radius-1);color:var(--color-text-body);cursor:pointer}:host ::ng-deep .ap-field-up.disabled{cursor:not-allowed}:host ::ng-deep .ap-field-up.readonly{display:none}:host ::ng-deep .ap-field-up:hover:not(.disabled):not(.readonly){background-color:var(--color-background-hover-selected)!important}:host ::ng-deep .ap-field-down{width:2.5rem;height:1.25rem;line-height:1.25rem;border-radius:var(--border-radius-1);color:var(--color-text-body);cursor:pointer}:host ::ng-deep .ap-field-down.disabled{cursor:not-allowed}:host ::ng-deep .ap-field-down.readonly{display:none}:host ::ng-deep .ap-field-down:hover:not(.disabled):not(.readonly){background-color:var(--color-background-hover-selected)!important}::ng-deep [data-keyboard-focus=true] .ap-field:not(.disabled):not(.readonly):not(.error):focus-within .ap-field-wrapper,::ng-deep [data-keyboard-focus=true] .ap-field:not(.disabled):not(.readonly):not(.error) .ap-field-container.show .ap-field-wrapper,::ng-deep [data-keyboard-focus=true] .ap-field:not(.disabled):not(.readonly):not(.error) .ap-field-container.open .ap-field-wrapper{box-shadow:inset 0 0 0 .0625rem var(--color-background-border)!important}::ng-deep [data-keyboard-focus=true] .ap-field:not(.disabled):not(.readonly):not(.error):focus-within .ap-field-wrapper.focus,::ng-deep [data-keyboard-focus=true] .ap-field:not(.disabled):not(.readonly):not(.error) .ap-field-container.show .ap-field-wrapper.focus,::ng-deep [data-keyboard-focus=true] .ap-field:not(.disabled):not(.readonly):not(.error) .ap-field-container.open .ap-field-wrapper.focus{outline:auto .125rem Highlight!important;outline:auto .3125rem -webkit-focus-ring-color!important;outline-offset:var(--spacing-1)}::ng-deep [data-keyboard-focus=true] .ap-field:not(.disabled).error:focus-within .ap-field-wrapper.focus,::ng-deep [data-keyboard-focus=true] .ap-field:not(.disabled).error .ap-field-container.show .ap-field-wrapper.focus,::ng-deep [data-keyboard-focus=true] .ap-field:not(.disabled).error .ap-field-container.open .ap-field-wrapper.focus{box-shadow:inset 0 0 0 .0625rem var(--color-background-border)!important;outline:auto .125rem Highlight!important;outline:auto .3125rem -webkit-focus-ring-color!important;outline-offset:var(--spacing-1)}::ng-deep [data-keyboard-focus=true] .ap-field.readonly .ap-field-container .ap-field-wrapper.focus{box-shadow:inset 0 0 0 .0625rem var(--color-background-border)!important;outline:auto .125rem Highlight;outline:auto .3125rem -webkit-focus-ring-color;outline-offset:var(--spacing-1)}::ng-deep .ap-field.error .ap-field-container .ap-field-wrapper .ap-field-dropdown-wrapper .ap-field-dropdown-button-group:not(.disabled):hover{background-color:rgba(var(--color-background-danger-rgb),var(--opacity-3))!important}\n"] }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i4.DialogService }, { type: i1.DatePipe }, { type: i5.DatepickerService }, { type: FieldService }, { type: i3.LocalizationConfig }, { type: i4.FocusIndicatorService }], propDecorators: { styleClass: [{
                type: Input
            }], style: [{
                type: Input
            }], dropdownButton: [{
                type: ViewChild,
                args: ["dropdownButton"]
            }], dropdownListItem: [{
                type: ContentChildren,
                args: ["dropdownListItem"]
            }], options: [{
                type: ViewChildren,
                args: ["option"]
            }], datepickerRef: [{
                type: ViewChild,
                args: ["datepickerRef"]
            }], titleContainerRef: [{
                type: ViewChild,
                args: ["titleContainerRef"]
            }], content: [{
                type: ViewChild,
                args: ["content"]
            }], inputRef: [{
                type: ContentChild,
                args: [FieldDirective]
            }], clearTextRef: [{
                type: ContentChild,
                args: [FieldCleanerComponent]
            }], numberRef: [{
                type: ContentChild,
                args: [FieldNumberComponent]
            }], textCounterRef: [{
                type: ContentChild,
                args: [FieldCounterComponent]
            }], title: [{
                type: Input
            }], error: [{
                type: Input
            }], disabled: [{
                type: Input
            }], selectedItem: [{
                type: Input
            }], customImg: [{
                type: Input
            }], img: [{
                type: Input
            }], unit: [{
                type: Input
            }], type: [{
                type: Input
            }], required: [{
                type: Input
            }], readonly: [{
                type: Input
            }], revealer: [{
                type: Input
            }], hideTitleOnInput: [{
                type: Input
            }], textReadonly: [{
                type: Input
            }], dropdown: [{
                type: Input
            }], fieldId: [{
                type: Input
            }], attachedDOM: [{
                type: Input
            }], adaptivePosition: [{
                type: Input
            }], minNum: [{
                type: Input
            }], maxNum: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], defaultNum: [{
                type: Input
            }], format: [{
                type: Input
            }], onNumberChange: [{
                type: Output
            }], onKeydown: [{
                type: Output
            }], onClick: [{
                type: Output
            }], onClose: [{
                type: Output
            }], onShow: [{
                type: Output
            }], onClickOutside: [{
                type: Output
            }], onListItemFocus: [{
                type: Output
            }], datepicker: [{
                type: Input
            }], editable: [{
                type: Input
            }], useCustomValidation: [{
                type: Input
            }], disableOutsideClose: [{
                type: Input
            }], dpLanguage: [{
                type: Input
            }], dpRange: [{
                type: Input
            }], dpAutoClose: [{
                type: Input
            }], dpCalendarPosition: [{
                type: Input
            }], dpType: [{
                type: Input
            }], dpCustom: [{
                type: Input
            }], dpOptions: [{
                type: Input
            }], dpMinDate: [{
                type: Input
            }], dpMaxDate: [{
                type: Input
            }], dpDisabledDates: [{
                type: Input
            }], dpDisabledRanges: [{
                type: Input
            }], dpDisabledDays: [{
                type: Input
            }], dpDateformat: [{
                type: Input
            }], dpDateSeparator: [{
                type: Input
            }], dpShowOtherMonths: [{
                type: Input
            }], dpRangeConnecterFormat: [{
                type: Input
            }], dpRangeConnectorFormat: [{
                type: Input
            }], dpFirstDayOfWeek: [{
                type: Input
            }], dpView: [{
                type: Input
            }], dpSelectedDates: [{
                type: Input
            }], dpSelectedDatesChange: [{
                type: Output
            }], dpOnDateInvalid: [{
                type: Output
            }], dpOnClickNavigators: [{
                type: Output
            }], onResizeEvent: [{
                type: HostListener,
                args: ["window:resize", ["$event"]]
            }], onScrollEvent: [{
                type: HostListener,
                args: ["window:scroll", ["$event"]]
            }] } });
class FieldModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.11", ngImport: i0, type: FieldModule, declarations: [FieldComponent, FieldDirective, FieldCleanerComponent, FieldCounterComponent, FieldNumberComponent], imports: [CommonModule, NgClickOutsideDirective, DatepickerModule], exports: [FieldComponent, FieldDirective, NgClickOutsideDirective, FieldCleanerComponent, FieldCounterComponent, FieldNumberComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FieldModule, providers: [DatePipe, FieldService], imports: [CommonModule, DatepickerModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: FieldModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, NgClickOutsideDirective, DatepickerModule],
                    declarations: [
                        FieldComponent,
                        FieldDirective,
                        FieldCleanerComponent,
                        FieldCounterComponent,
                        FieldNumberComponent,
                    ],
                    exports: [
                        FieldComponent,
                        FieldDirective,
                        NgClickOutsideDirective,
                        FieldCleanerComponent,
                        FieldCounterComponent,
                        FieldNumberComponent,
                    ],
                    providers: [DatePipe, FieldService],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FIELD_COMPONENT, FieldCleanerComponent, FieldComponent, FieldCounterComponent, FieldDirective, FieldModule, FieldNumberComponent, FieldService };
